import {
  Button,
  Checkbox,
  Grid,
  TableContainer,
  Typography,
  MenuItem,
  Table,
  Select,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  FormControl,
  FormControlLabel,
  Autocomplete,
  FormGroup,
  Switch,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Field, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import * as Yup from "yup";
import FormikInput1 from "../../shared/material-ui-formik/FormikInput1";
import { makeCheckOut } from "../../apis/services/BookingApiService";
import { toast } from "react-toastify";
import moment from "moment";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import {
  createRecord,
  fetchList,
  getRecord,
} from "../../apis/services/CommonApiService";
import {
  cryptoEncryptData,
  getCardMerchantType,
  getPaymentTypeOfBooking,
} from "../../utils/helper";
import Loader from "../../layout/Loader";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import ConfirmDialog from "../../shared/components/ConfirmDialog";
import { getLoadingFailed, getLoadingSuccess } from "../../Reducer/authSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  chargeLessDetailFailed,
  pinpadDevicesListFailed,
  pinpadDevicesListSuccess,
} from "../../Reducer/bookingSlice";
import DialogForm from "../../shared/components/DialogForm";
import { VerifyCard } from "../../apis/services/VerifyCard";

const CheckOutValidations = Yup.object().shape({
  check_out_time: Yup.string().required("Check Out Time Is Required"),
});

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          theme.palette.mode === "dark" ? "#2ECA45" : "rgb(28, 58, 102)",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const ReservationCheckOut = (props) => {
  const bookingInfo = props.editedData;
  const auth = useSelector((state) => state.auth);
  const pinpadDevicesList = useSelector(
    (state) => state.booking?.pinpadDevicesList,
  );
  const chargeLessDetail = useSelector(
    (state) => state.booking?.chargeLessDetail,
  );

  const [yearList, setYearList] = useState([]);
  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  // console.log("bookingInfo", bookingInfo);
  const handleDialogClose = props.handleDialogOutClose;
  const refreshData = props.refreshCheckInOutListCall;
  const [folioData, setFolioData] = useState([]);
  const [bookingDetail, setBookingDetail] = useState([]);
  const [tab, setTab] = useState(0);
  const [check, setCheck] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [final_amount, setFinal_amount] = React.useState(0);
  const [old_captured_amount, set_old_captured_amount] = React.useState(0);
  const [openCashRefundDialog, setOpenCashRefundDialog] = useState(false);
  const [openCreditCardDialog, setOpenCreditCardDialog] = useState(false);
  const [refundSelectedCard, setRefundSelectedCard] = useState([]);
  const [cashBySysyem, setCashBySystem] = useState(true);
  const [guest_count, setGuest_count] = useState([]);
  const [guests_count, setGuests_count] = useState([]);
  const [split_bill, setSplit_Bill] = useState(0);
  const [charge_less, setCharge_less] = useState(0);
  const [charge_less_detail, setCharge_less_detail] = useState({
    final_capture_amount: +bookingInfo?.final_amount || 0,
    description: "",
    discount: 0,
    night: +bookingInfo?.no_of_days || 1,
    sub_total:
      +(+bookingInfo?.final_amount - +bookingInfo?.total_tax).toFixed(2) || 0,
    reedemed_reward_value: +bookingInfo?.total_redeem_value || 0,
    tax_percentage:
      +bookingInfo?.booking_source === 3
        ? (+bookingInfo?.total_tax * 100) /
          (+bookingInfo?.final_amount - +bookingInfo?.total_tax)
        : bookingInfo?.bookingTaxDetails
            ?.filter((tax) => tax?.taxInfo?.tax_type === 1)
            ?.reduce((n, { taxInfo }) => +n + +(taxInfo?.tax_rate || 0), 0),
    tax_flat:
      bookingInfo?.bookingTaxDetails
        ?.filter((tax) => tax?.taxInfo?.tax_type === 2)
        ?.reduce((n, { taxInfo }) => +n + +(taxInfo?.tax_rate || 0), 0) || 0,
  });

  // console.log(charge_less_detail, 161);
  // console.log(refundSelectedCard, 165);
  const [hotelId, setHotelId] = useState(null);
  const [salesItemInfo, setSalesItemInfo] = useState([
    {
      index: "",
      id: "",
      name: "",
      price: "",
      quantity: "",
      discount: "",
      sub_total: "",
      total: "",
      addonList: [],
      addon_total: 0,
    },
  ]);
  const [bookingItemInfo, setBookingItemInfo] = useState([]);
  const [print, setPrint] = useState(false);
  const handleChangePrint = (checked) => {
    setPrint(checked);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      +chargeLessDetail?.charge_less === 1 &&
      +bookingInfo?.id === +chargeLessDetail?.booking_id
    ) {
      setCharge_less(1);
      setCharge_less_detail({
        final_capture_amount: chargeLessDetail?.final_capture_amount,
        description: chargeLessDetail?.description,
        discount: chargeLessDetail?.discount,
        night: chargeLessDetail?.night,
        sub_total: chargeLessDetail?.sub_total,
        tax_percentage: chargeLessDetail?.tax_percentage,
        tax_flat: chargeLessDetail?.tax_flat,
        reedemed_reward_value: chargeLessDetail?.reedemed_reward_value,
      });
    }
  }, [chargeLessDetail]);

  const getRateSpecificCal = (roomRate, daydiff, rateType) => {
    let date = bookingInfo?.checkin_date;
    let price = 0;
    while (
      moment(date).diff(moment(bookingInfo?.checkin_date), "days") < daydiff
    ) {
      let filBookingRate = roomRate?.find((item) => item?.date === date);
      price = price + +filBookingRate?.[rateType];
      date = moment(date).add(1, "days").format("YYYY-MM-DD");
    }
    return price;
  };

  const getSubTotal = (
    roomRateDetail,
    night,
    no_of_extra_adults,
    no_of_extra_children,
    discountPercentage,
  ) => {
    //  console.log(roomRateDetail, night,no_of_extra_adults, no_of_extra_children, discountPercentage, 193);
    let room_price =
      ((getRateSpecificCal(roomRateDetail, night, "min_occupancy_rate") +
        getRateSpecificCal(roomRateDetail, night, "extra_adult_rate") *
          no_of_extra_adults +
        getRateSpecificCal(roomRateDetail, night, "child_rate") *
          no_of_extra_children) *
        (100 - discountPercentage)) /
      100;
    return +room_price.toFixed(2);
  };

  useEffect(() => {
    const bookingItemsDataList = [];
    if (
      bookingInfo?.bookingItemsData !== null &&
      bookingInfo?.bookingItemsData.length >= 0
    ) {
      let pkgData = bookingInfo?.bookingPackages;
      let packagePerNight = 0;
      let packageOneTime = 0;
      let packagePerPerson = 0;
      pkgData?.forEach((pkg) => {
        if (pkg?.charge_type === 1) {
          packagePerNight += +pkg?.unit_price || 0;
        } else if (pkg?.charge_type === 2) {
          packageOneTime += +pkg?.unit_price || 0;
        } else if (pkg?.charge_type === 3) {
          packagePerPerson += +pkg?.unit_price || 0;
        }
      });
      for (var j in bookingInfo?.bookingItemsData) {
        const totalDiscount =
          +bookingInfo?.bookingItemsData[j]?.total_discount || 0;
        const subtotal = +getSubTotal(
          bookingInfo?.bookingItemsData[j]?.roomRateDetail,
          +bookingInfo?.no_of_days,
          +bookingInfo?.bookingItemsData[j]?.no_of_extra_adults,
          +bookingInfo?.bookingItemsData[j]?.no_of_extra_children,
          0,
        );
        const discountDenominator = subtotal + totalDiscount;
        const discountPercentage =
          discountDenominator > 0
            ? +((totalDiscount * 100) / discountDenominator).toFixed(2)
            : 0;

        let packagePerPersonAmount =
          +packagePerPerson *
          (+bookingInfo?.bookingItemsData[j].no_of_extra_adults +
            +bookingInfo?.bookingItemsData[j].no_of_adults +
            +bookingInfo?.bookingItemsData[j].no_of_extra_children +
            +bookingInfo?.bookingItemsData[j].no_of_children);

        // console.log(totalDiscount, subtotal, discountPercentage, 213);
        bookingItemsDataList.push({
          id: bookingInfo?.bookingItemsData[j]?.id,
          oneNightRoomSubTotal:
            +bookingInfo?.bookingItemsData[j]?.room_price +
            +bookingInfo?.bookingItemsData[j]?.extra_adult_price *
              +bookingInfo?.bookingItemsData[j]?.no_of_extra_adults +
            +bookingInfo?.bookingItemsData[j]?.child_price *
              +bookingInfo?.bookingItemsData[j]?.no_of_extra_children -
            +bookingInfo?.bookingItemsData[j]?.total_discount /
              +bookingInfo?.no_of_days,
          oneNightRoomTotalWithoutDiscount:
            +bookingInfo?.bookingItemsData[j]?.room_price +
            +bookingInfo?.bookingItemsData[j]?.extra_adult_price *
              +bookingInfo?.bookingItemsData[j]?.no_of_extra_adults +
            +bookingInfo?.bookingItemsData[j]?.child_price *
              +bookingInfo?.bookingItemsData[j]?.no_of_extra_children,
          oneNightDefaultDiscount:
            +bookingInfo?.bookingItemsData[j]?.total_discount /
            +bookingInfo?.no_of_days,
          no_of_extra_adults:
            +bookingInfo?.bookingItemsData[j]?.no_of_extra_adults,
          no_of_extra_children:
            +bookingInfo?.bookingItemsData[j]?.no_of_extra_children,
          no_of_adults: +bookingInfo?.bookingItemsData[j].no_of_adults,
          no_of_children: +bookingInfo?.bookingItemsData[j].no_of_children,
          discountPercentage: +discountPercentage.toFixed(2),
          roomRateDetail: bookingInfo?.bookingItemsData[j]?.roomRateDetail,
          oneNightAddon:
            +bookingInfo?.bookingItemsData[j]?.addon_total /
            +bookingInfo?.no_of_days,
          oneNightAddonList: bookingInfo?.bookingItemsData[
            j
          ]?.bookingAddonDetail?.map((item) => ({
            id: item?.id,
            amount: +(+item?.amount / +bookingInfo?.no_of_days).toFixed(2),
          })),
          packagePerNight: +packagePerNight,
          bookingRedemptions: bookingInfo?.bookingRedemptions,
          total_redeem_value: +bookingInfo?.total_redeem_value || 0,
          total_redeem_per_night: +(
            +bookingInfo?.total_redeem_value / +bookingInfo?.no_of_days
          ).toFixed(2),
          final_amount: +(+bookingInfo?.bookingItemsData[j]?.final_amount +
           +bookingInfo?.bookingItemsData[j]?.redeem_value).toFixed(2),
          packageOneTime: +packageOneTime + +packagePerPersonAmount,
        });
      }
      setBookingItemInfo(bookingItemsDataList);
    }
  }, [bookingInfo]);

  // console.log(bookingItemInfo,bookingInfo, "bookingItemInfo");

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("userDetails"));
    if (items) {
      setHotelId(items.hotel_id);
    }
    let currentMonth = moment().format("YYYY");
    let yearArray = [];
    for (let i = 0; i < 100; i++) {
      yearArray.push((i + Number(currentMonth)).toString());
    }
    setYearList(yearArray);
  }, []);

  const { t } = useTranslation();
  const handleTabs = (num) => {
    setTab(num);
  };
  const getFolioDetails = async () => {
    //  dispatch(getLoadingSuccess());
    setLoading(true);
    const result = await fetchList(
      ApiEndPoints.GET_BOOKING_FOLIO_DETAILS + `/${bookingInfo?.id}`,
    );
    if (result?.status === 200) {
      setFolioData(result.data);
      // dispatch(getLoadingFailed());
      setLoading(false);
    } else {
      setFolioData([]);
      // dispatch(getLoadingFailed());
      setLoading(false);
    }
  };

  const getCapturedAmount = async () => {
    const pendingAmounts = await getRecord(
      bookingInfo?.id,
      ApiEndPoints.GET_BOOKING_PENDING_AMOUNT,
    );

    if (pendingAmounts?.status === 200) {
      set_old_captured_amount(+pendingAmounts?.data);
      return pendingAmounts?.data;
    } else {
      set_old_captured_amount(0);
      return 0;
    }
  };

  const getReservationDetails = async () => {
    // dispatch(getLoadingSuccess());
    setLoading(true);

    const result = await fetchList(
      ApiEndPoints.GET_BOOKING_DETAILS + `/${bookingInfo?.id}`,
    );
    const pendingAmounts = await getRecord(
      bookingInfo?.id,
      ApiEndPoints.GET_BOOKING_PENDING_AMOUNT,
    );

    if (result?.status === 200) {
      if (pendingAmounts?.status === 200) {
        set_old_captured_amount(pendingAmounts?.data);
        setFinal_amount(
          +(+result?.data?.final_amount - +pendingAmounts?.data).toFixed(2),
        );
      } else {
        setFinal_amount(+(+result?.data?.final_amount).toFixed(2));
        set_old_captured_amount(0);
      }
      // setFinal_amount(result?.data?.final_amount - pendingAmounts?.data)
      setBookingDetail(result.data);
      const salesItemsDataList = [];

      if (
        result.data?.salesItemsData !== null &&
        result.data?.salesItemsData.length >= 0
      ) {
        for (let j in result.data?.salesItemsData) {
          salesItemsDataList.push({
            index: +j + 1,
            id: result.data?.salesItemsData[j]?.id,
            name: result.data?.salesItemsData[j]?.productInfo.name,
            quantity: result.data?.salesItemsData[j].quantity,
            price: result.data?.salesItemsData[j].price,
            discount: result.data?.salesItemsData[j].discount,
            sub_total: result.data?.salesItemsData[j].sub_total,
            total: result.data?.salesItemsData[j].total,
            addonList: result.data[j]?.addonList,
            addon_total: +result.data?.salesItemsData[j]?.addon_total,
          });
          if (result.data?.salesItemsData[j]?.addonList?.length > 0) {
            for (let t in result.data?.salesItemsData[j]?.addonList) {
              salesItemsDataList.push({
                index: "",
                id: result.data?.salesItemsData[j].addonList[t]?.id,
                name: result.data?.salesItemsData[j]?.addonList[t]?.addonInfo
                  .name,
                quantity: result.data?.salesItemsData[j].addonList[t].quantity,
                price: result.data?.salesItemsData[j].addonList[t].price,
                discount: result.data?.salesItemsData[j].addonList[t].discount,
                sub_total:
                  result.data?.salesItemsData[j].addonList[t].sub_total,
                total: "",
                addon_total:
                  +result.data?.salesItemsData[j]?.addonList[t]?.total,
              });
            }
          }
        }

        setSalesItemInfo(salesItemsDataList);
      }
      // dispatch(getLoadingFailed());
      setLoading(false);
    } else {
      setBookingDetail([]);
      // dispatch(getLoadingFailed());
      setLoading(false);
    }
  };

  useState(() => {
    getReservationDetails();
    getFolioDetails();
  }, []);

  const initialState = {
    booking_id: bookingInfo?.id,
    check_out_time: moment().format("HH:mm"),
    is_late_check_out: 0,
    late_check_out_price: 0,
    split_bill: 0,
    payment_type: 1,
    // final_amounts: final_amount,
    guest_split: guest_count,
    final_capture_amount: +bookingInfo?.final_amount || 0,
    is_custom_capture: 0,
    night: 0,
    description: "",
    // guest_count: 0,
  };
  // Guest

  const handleChargeNight = (e) => {
    const { value } = e.target;
    let sub_total =
      +(
        (bookingItemInfo?.reduce(
          (sum, item) =>
            sum +
            getSubTotal(
              item.roomRateDetail,
              +value,
              item.no_of_extra_adults,
              item.no_of_extra_children,
              item.discountPercentage,
            ),
          0,
        ) *
          (100 - +charge_less_detail?.discount)) /
        100
      ) +
      bookingItemInfo?.reduce((sum, item) => sum + item.oneNightAddon, 0) *
        +value +
      +bookingItemInfo?.reduce((sum, item) => sum + item.packagePerNight, 0) *
        +value +
      +bookingItemInfo?.reduce((sum, item) => sum + item.packageOneTime, 0);
      let reedemed_reward_value = +((+bookingItemInfo?.[0]?.total_redeem_value * +sub_total)/+bookingItemInfo?.[0]?.final_amount).toFixed(2);
    sub_total = +(+sub_total - +reedemed_reward_value).toFixed(2);
    let final_capture_amount = +(
      (+sub_total * +charge_less_detail?.tax_percentage) / 100 +
      +charge_less_detail?.tax_flat * +value +
      +sub_total
    ).toFixed(2);

    setCharge_less_detail((prev) => ({
      ...prev,
      night: +value,
      sub_total: sub_total,
      final_capture_amount: final_capture_amount,
      reedemed_reward_value: reedemed_reward_value || 0,

      // final_capture_amount: +(
      //   (+value *
      //     bookingItemInfo?.reduce((sum, item) => sum + item.oneNightAmount, 0) *
      //     (100 - +charge_less_detail?.discount)) /
      //   100
      // )?.toFixed(2),
    }));
  };

  const handleChargeCapture = (e, setFieldValue) => {
    const { name, value } = e.target;
    if (name === "description") {
      setCharge_less_detail((prev) => ({
        ...prev,
        description: value,
      }));
    }
    if (name === "final_capture_amount") {
      // setFieldValue("night", 0);
      setCharge_less_detail((prev) => ({
        ...prev,
        night: 0,
      }));
      if (value >= 0) {
        setCharge_less_detail((prev) => ({
          ...prev,
          night: 0,
          final_capture_amount: +value,
        }));
      }
    }
  };

  const handleDiscountChargeCapture = (e) => {
    const { value } = e.target;
    if (+value > 100) {
      toast.error("Discount (in %) should be less then 100");
      return;
    }
    if (+value < 0) {
      toast.error("Discount (in %) should be greater then or equal 0");
      return;
    }

    let sub_total = +(
      (bookingItemInfo?.reduce(
        (sum, item) =>
          sum +
          getSubTotal(
            item.roomRateDetail,
            +charge_less_detail?.night,
            item.no_of_extra_adults,
            item.no_of_extra_children,
            item.discountPercentage,
          ),
        0,
      ) *
        (100 - +value)) /
        100 +
      bookingItemInfo?.reduce((sum, item) => sum + item.oneNightAddon, 0) *
        +charge_less_detail?.night +
      +bookingItemInfo?.reduce((sum, item) => sum + item.packagePerNight, 0) *
        +charge_less_detail?.night +
      +bookingItemInfo?.reduce((sum, item) => sum + item.packageOneTime, 0) 
    )?.toFixed(2);
    let reedemed_reward_value = +((+bookingItemInfo?.[0]?.total_redeem_value * +sub_total)/+bookingItemInfo?.[0]?.final_amount).toFixed(2);

    sub_total = +(+sub_total - +reedemed_reward_value).toFixed(2);

    let final_capture_amount = +(
      (sub_total * charge_less_detail?.tax_percentage) / 100 +
      charge_less_detail?.tax_flat * +charge_less_detail?.night +
      sub_total
    ).toFixed(2);

    setCharge_less_detail((prev) => ({
      ...prev,
      discount: +value,
      sub_total: sub_total,
      final_capture_amount: final_capture_amount,
      reedemed_reward_value:
        +(
          reedemed_reward_value
        ).toFixed(2) || 0,
      // final_capture_amount: +(
      //   (+charge_less_detail?.night *
      //     bookingItemInfo?.reduce((sum, item) => sum + item.oneNightAmount, 0) *
      //     (100 - +value)) /
      //   100
      // )?.toFixed(2),
    }));
  };

  const [searchUserResult, setSearchUserResult] = useState([]);
  const searchUserApi = async (searchUserText) => {
    // dispatch(getLoadingSuccess());
    setLoading(true);
    const result = await fetchList(
      ApiEndPoints.USER_AUTOCOMPLETE + `?search_text=${searchUserText}`,
    );
    const guestList = [];
    if (result?.status === 200) {
      for (let j in result.data) {
        guestList.push({
          value: result.data[j].id,
          label: result.data[j].name,
        });
      }
      setSearchUserResult(guestList);
      // dispatch(getLoadingFailed());
      setLoading(false);
    } else {
      setSearchUserResult([]);
      // dispatch(getLoadingFailed());
      setLoading(false);
    }
  };

  const onSearchInputChange = (event) => {
    if (event === null) {
      setSearchUserResult([]);
    } else {
      const { value } = event.target;
      if (value) {
        searchUserApi(value);
      } else {
        setSearchUserResult([]);
      }
    }
  };

  // useEffect(() => {
  //   searchUserApi();
  // }, []);

  // guest payment
  const [cardDetail, setCardDetail] = useState([]);

  const paymentType = [
    {
      id: 2,
      name: "Credit Card",
    },
    // {
    //   id: 3,
    //   name: "Cheque",
    // },
  ];

  if (props.isCashAllowed === 1) {
    paymentType.push({
      id: 1,
      name: "Cash",
    });
  }

  const handleGuestAmount = (e, index, setFieldValue) => {
    const data1 = guest_count.find((item, ind) => ind === index);
    setFieldValue(`guest_split${index}.amount`, e.target.value);
    data1.amount = e.target.value;
  };

  const handleCardPresent = (e, index, setFieldValue) => {
    const data1 = guest_count.find((item, ind) => ind === index);
    if (e.target.checked === true) {
      data1.card_present = 1;
      setFieldValue(`guest_split.${index}.card_present`, 1);
    } else {
      data1.card_present = 0;
      setFieldValue(`guest_split.${index}.card_present`, 0);
    }
  };

  const handlePaymentType = (e, index, setFieldValue) => {
    const data1 = guest_count.find((item, ind) => ind === index);
    data1.payment_type = e.target.value;
    setFieldValue(`guest_split.${index}.payment_type`, e.target.value);
  };

  const ClearCradDetail = (index, setFieldValue) => {
    const data1 = guest_count.find((item, ind) => ind === index);
    data1.payment_card_detail.card_holder_name = "";
    data1.payment_card_detail.card_number = "";
    data1.payment_card_detail.cvv = "";
    data1.payment_card_detail.id = 0;
    data1.payment_card_detail.mm = "";
    data1.payment_card_detail.yyy = "";
    // data1.payment_card_detail.user_id = "";
    data1.payment_card_detail.card_type = "";
    data1.card_verify_token = "";
    setFieldValue(`guest_split.${index}.card_verify_token`, "");
    // setFieldValue(`guest_split.${index}.payment_card_detail.user_id`, "");
    setFieldValue(`guest_split.${index}.payment_card_detail.card_type`, "");
    setFieldValue(
      `guest_split.${index}.payment_card_detail.card_holder_name`,
      "",
    );
    setFieldValue(`guest_split.${index}.payment_card_detail.card_number`, "");
    setFieldValue(`guest_split.${index}.payment_card_detail.yyy`, "");
    setFieldValue(`guest_split.${index}.payment_card_detail.mm`, "");
    setFieldValue(`guest_split.${index}.payment_card_detail.cvv`, "");
  };

  const handleSuOn = (e, index, setFieldValue, values) => {
    const data1 = guest_count.find((item, ind) => ind === index);

    setFieldValue(`guest_split.${index}.suOn`, e.target.checked);
    data1.suOn = e.target.checked;
    // console.log(352, values);
  };

  const getCradsDetail = async (e, value, index, setFieldValue) => {
    ClearCradDetail(index, setFieldValue);
    const data1 = guest_count.find((item, ind) => ind === index);
    data1.guest = value;
    const user_id = value.value;
    // dispatch(getLoadingSuccess());
    setLoading(true);

    const result = await getRecord(user_id, ApiEndPoints.GET_USER_CARD_DETAIL);
    const CardList = [];
    if (result?.status === 200) {
      for (var j in result.data) {
        CardList.push({
          id: result.data[j].id,
          user_id: result.data[j].user_id,
          card_holder_name: result.data[j].card_holder_name,
          card_number: result.data[j].card_number,
          expiry_date: result.data[j].expiry_date,
          cvv: result.data[j].cvv,
          token: result.data[j].token,
          card_type: result.data[j].card_type,
        });
      }
      setCardDetail(CardList);
      data1.payment_card = CardList;
      setFieldValue(`guest_split.${index}.payment_card`, CardList);
      if (
        +bookingDetail?.user_id === +user_id &&
        bookingDetail?.su_pg_id &&
        data1.pay !== 1 &&
        e !== 1
      ) {
        setFieldValue(`guest_split.${index}.suToken`, bookingDetail?.su_pg_id);
        setFieldValue(`guest_split.${index}.suOn`, true);
        data1.suToken = bookingDetail?.su_pg_id;
        data1.suOn = true;
      }
      // dispatch(getLoadingFailed());
      setLoading(false);
    } else {
      setCardDetail([]);
      // dispatch(getLoadingFailed());
      setLoading(false);
    }
  };
  // Pinpad Devices
  // const [pinpadDevicesList, setPinpadDevicesList] = useState([]);
  const [selectPinpadDevices, setSelectPinpadDevices] = useState("");

  const handlePinpadDevice = (e, index, setFieldValue) => {
    setSelectPinpadDevices(e.target.value);
    const data1 = guest_count.find((item, ind) => ind === index);
    data1.selectPinpadDevices = e.target.value;
  };
  useEffect(() => {
    if (pinpadDevicesList?.length === 0) {
      getPinpadDevicesDetail();
    }
  }, []);
  const getPinpadDevicesDetail = async () => {
    const result = await fetchList(ApiEndPoints.GET_ALL_PINPAD_DEVICE);
    if (result?.status === 200) {
      dispatch(pinpadDevicesListSuccess(result?.data));
      // setPinpadDevicesList(result?.data);
    } else {
      dispatch(pinpadDevicesListFailed(result?.data));
      // setPinpadDevicesList([]);
    }
  };

  const payNow = async (
    e,
    index,
    setFieldValue,
    data,
    guest,
    payment_card_detail,
    payment_cheque_detail,
    amount,
    payment_type,
    card_present,
    verify_token,
    selectPinpadDevices,
    suToken,
    suOn,
  ) => {
    const data1 = guest_count.find((item, ind) => ind === index);
    const guest_amount = Number.parseFloat(amount).toFixed(2);
    // console.log(amount, guest_amount, 451);

    if (guest?.value === undefined) {
      toast.error(`${t("you must select Guest")} (${index + 1})`);
      return;
    }

    if (
      Number.parseInt(guest_amount.split(".")[0]) >
      Number.parseInt(final_amount)
    ) {
      toast.error(
        t("Amount should not be greater then your remaining amount."),
      );
      // return;
    } else {
      if (card_present === 1 && selectPinpadDevices === 0) {
        toast.error(t("To confirm the pay, you must select Pinpad Device"));
        return;
      }

      let bodyFormData = {
        booking_id: bookingInfo?.id,
        user_id: guest?.value === undefined ? "" : guest?.value,
        amount: amount === undefined ? "" : amount,
        payment_type: payment_type === undefined ? "" : payment_type,
        card_present:
          card_present === undefined || payment_type === 1 ? "" : card_present,
        token: verify_token === undefined ? "" : verify_token,
        credit_card_id:
          payment_card_detail?.id === undefined
            ? ""
            : card_present
              ? ""
              : payment_card_detail?.id,
        cheque_number:
          payment_cheque_detail?.cheque_number === undefined
            ? ""
            : payment_cheque_detail?.cheque_number,
        bank_name:
          payment_cheque_detail?.bank_name === undefined
            ? ""
            : payment_cheque_detail?.bank_name,
        device_id: selectPinpadDevices === 0 ? "" : selectPinpadDevices,
      };

      if ((+card_present === 0 || card_present === undefined) && suOn) {
        bodyFormData.su_token = suToken;
      }
      // dispatch(getLoadingSuccess());
      setLoading(true);
      const results = await createRecord(
        bodyFormData,
        ApiEndPoints.SPLIT_PAY_NOW,
      );
      if (results?.status === 200) {
        // dispatch(getLoadingFailed());
        setLoading(false);
        const finalAmount = final_amount - amount;
        setFinal_amount(finalAmount?.toFixed(2));
        data1.pay = 1;
        setFieldValue(`guest_split.${index}.pay`, 1);
        getFolioDetails();
        toast.success(t(results?.message));
      } else if (results?.status === 400) {
        data1.pay = 0;
        // dispatch(getLoadingFailed());
        setLoading(false);
        toast.error(t(results?.message));
      } else if (results === undefined) {
        // dispatch(getLoadingFailed());
        setLoading(false);
        data1.pay = 0;
        toast.error(t(results?.message));
      } else {
        data1.pay = 0;
        // dispatch(getLoadingFailed());
        setLoading(false);
        toast.error(t(results?.message));
      }
    }
  };

  const handleCardDetail = (e, index, setFieldValue) => {
    const id = e.target.value;
    const data = cardDetail?.find((item) => item?.id === id);
    const data1 = guest_count.find((item, ind) => ind === index);

    if (e.target.value === 0) {
      ClearCradDetail(index, setFieldValue);
    } else {
      data1.payment_card_detail.card_holder_name = data?.card_holder_name;
      data1.payment_card_detail.card_number = data?.card_number;
      data1.payment_card_detail.cvv = data?.cvv;
      data1.payment_card_detail.id = id;
      data1.payment_card_detail.mm = data?.expiry_date.split("-")[1];
      data1.payment_card_detail.yyy = data?.expiry_date.split("-")[1];
      data1.payment_card_detail.user_id = data?.user_id;
      data1.payment_card_detail.card_type = data?.card_type;
      data1.card_verify_token = data?.token;
      setFieldValue(`guest_split.${index}.card_verify_token`, data?.token);
      setFieldValue(`guest_split.${index}.payment_card_detail.id`, id);
      setFieldValue(
        `guest_split.${index}.payment_card_detail.card_type`,
        data?.card_type,
      );
      setFieldValue(
        `guest_split.${index}.payment_card_detail.user_id`,
        data?.user_id,
      );
      setFieldValue(
        `guest_split.${index}.payment_card_detail.card_holder_name`,
        data?.card_holder_name,
      );
      setFieldValue(
        `guest_split.${index}.payment_card_detail.card_number`,
        data?.card_number,
      );
      setFieldValue(
        `guest_split.${index}.payment_card_detail.yyy`,
        data?.expiry_date.split("-")[0],
      );
      setFieldValue(
        `guest_split.${index}.payment_card_detail.mm`,
        data?.expiry_date.split("-")[1],
      );
      setFieldValue(`guest_split.${index}.payment_card_detail.cvv`, data?.cvv);
    }
  };

  const addCardDetail = async (
    index,
    setFieldValue,
    guest,
    payment_card_detail,
  ) => {
    // setFieldValue(`guest_split.${index}.payment_type`, 2);
    if (guest?.value === undefined) {
      toast.error(`${t("you must select Guest")} (${index + 1})`);
      return;
    }

    if (
      payment_card_detail?.card_holder_name === "" ||
      payment_card_detail?.yyy === "" ||
      payment_card_detail?.card_number === "" ||
      payment_card_detail?.mm === ""
      // || payment_card_detail?.cvv === 0
    ) {
      toast.error(`${t("You Must Add Card Detail on Guest")} (${index + 1})`);
      return;
    }

    if (payment_card_detail?.card_number?.length < 8) {
      toast.error("Please, enter valid card number " + (index + 1));
      return;
    }

    const data1 = guest_count.find((item, ind) => ind === index);
    // dispatch(getLoadingSuccess());
    setLoading(true);
    const name = payment_card_detail?.card_holder_name?.trim().split(/\s+/);
    const yyyDAT = payment_card_detail?.yyy.toString();
    const expiry_date_yyy = yyyDAT?.split("");
    const bodyFormData = {
      user_id: parseInt(guest?.value),
      card_number: cryptoEncryptData(
        parseInt(payment_card_detail?.card_number)?.toString(),
      ),
      expiry_date: cryptoEncryptData(
        `${payment_card_detail?.mm}${
          expiry_date_yyy[expiry_date_yyy.length - 2]
        }${expiry_date_yyy[expiry_date_yyy.length - 1]}`?.toString(),
      ),
      first_name: name[0],
      last_name: name[1] ? name[1] : "",
      security_code: cryptoEncryptData(payment_card_detail?.cvv?.toString()),
    };
    const result = await VerifyCard(bodyFormData, payment_card_detail);

    if (result?.status === 200) {
      const bodyFormData = result?.bodyFormData;

      const results = await createRecord(
        bodyFormData,
        ApiEndPoints.ADD_USER_CARD_DETAIL,
      );
      if (results?.status === 200) {
        toast.success(t(results?.message));
        getCradsDetail(1, data1.guest, index, setFieldValue);
        setLoading(false);
      } else {
        // dispatch(getLoadingFailed());
        setLoading(false);
        toast.error(t(results?.message));
      }
    } else {
      // dispatch(getLoadingFailed());
      setLoading(false);
    }
  };

  const handleGuestCount = (e, setFieldValue) => {
    const value = Math.max(0, Number(e.target.value)); // Ensure value is at least 0

    // const value = e.target.value;
    setGuests_count(value);
    // setFieldValue(`guest_count`, value);
    const count = [];
    for (let i = 0; i < value; i++) {
      count.push(i);
    }
    const data = count?.map((item, index) => {
      return {
        guest: "",
        amount: 0,
        payment_card: [],
        payment_type: 0,
        card_present: 0,
        card_verify_token: "",
        selectPinpadDevices: 0,
        pay: 0,
        payment_card_detail: {
          id: 0,
          user_id: "",
          card_holder_name: "",
          card_number: "",
          yyy: "",
          mm: "",
          cvv: "",
          card_type: "",
        },
        suToken: null,
        suOn: false,
      };
    });
    setGuest_count(data);
  };

  const [openSendSmsEmailDialog, setOpenSendSmsEmailDialog] = useState(false);
  const [checkOutValues, setCheckOutValues] = useState({});
  const [rewardRevertValues, setRewardRevertValues] = useState([]);
  const [is_reward_revert, setIs_reward_revert] = useState(false);
  const [rewardRevertConfirmDialog, setRewardRevertConfirmDialog] =
    useState(false);
  const [rewardRevertSelectDialog, setRewardRevertSelectDialog] =
    useState(false);

  const handleOpenSmsEmail = (values) => {
    if (charge_less === 1) {
      if (charge_less_detail?.final_capture_amount < 0) {
        toast.error(t("Please Add Charge Amount"));
        return;
      }
      if (charge_less_detail?.description === "") {
        toast.error(t("Please Add Description on less charge amount"));
        return;
      }
    }
    setCheckOutValues(values);
    setOpenSendSmsEmailDialog(true);
  };

  const handleConfirmRewardRevert = (values, checkOutValues) => {
    setRewardRevertConfirmDialog(false);
    if(values){
      setIs_reward_revert(true);
      if(bookingInfo?.bookingRedemptions?.length > 1){
      setRewardRevertSelectDialog(true);
      } else {
        handleConfirm(checkOutValues);
      }
    } else {
      setIs_reward_revert(false);
      setRewardRevertValues([]);
      handleConfirm(checkOutValues);
    }
  };

  const handleConfirmWithReward = (values) => {
    setCheckOutValues(values);
    if(+bookingInfo?.total_redeem_value !== +charge_less_detail?.reedemed_reward_value){
      // setRewardRevertConfirmDialog(true);
      handleConfirmRewardRevert(true, values);
    } else {
      setIs_reward_revert(false);
      handleConfirm(values);
    }
  }

  const handleSubmit = async (values, send_sms) => {
    console.log(values, "checkOutValues");
    const bookingItemsTable = [];
    let refund_info = [];
    let bookingTable = {};
    let revert_reward_info = [];

    dispatch(getLoadingSuccess());
    if (charge_less === 1) {
      bookingItemInfo?.forEach((item) => {
        let oneNightRoomTotalWithoutDiscount = getSubTotal(
          item.roomRateDetail,
          +charge_less_detail.night,
          item.no_of_extra_adults,
          item.no_of_extra_children,
          0,
        );
        let oneNightRoomSubTotal = getSubTotal(
          item.roomRateDetail,
          +charge_less_detail.night,
          item.no_of_extra_adults,
          item.no_of_extra_children,
          item.discountPercentage,
        );
        let oneNightWithNewDiscountSubTotal =
          (oneNightRoomSubTotal * (100 - charge_less_detail?.discount)) / 100;
        let totalDiscount =
          oneNightRoomTotalWithoutDiscount - oneNightWithNewDiscountSubTotal;
        let discountPercentage =
          (totalDiscount * 100) / oneNightRoomTotalWithoutDiscount;
        let total_discount = totalDiscount;
        let rooms_total = oneNightRoomTotalWithoutDiscount;
        let sub_total = oneNightWithNewDiscountSubTotal - +charge_less_detail?.reedemed_reward_value;
        let final_amount =
          oneNightWithNewDiscountSubTotal +
          item?.oneNightAddon * +charge_less_detail?.night +
          item?.packagePerNight * +charge_less_detail?.night +
          item?.packageOneTime - +charge_less_detail?.reedemed_reward_value;

        let bookingTaxDetails = [];
        bookingInfo?.bookingTaxDetails?.forEach((tax) => {
          let tax_per = +tax?.taxInfo?.tax_rate;
          if (tax?.tax_id === 0) {
            tax_per =
              (+tax?.amount * 100) /
              (+bookingDetail?.final_amount - +bookingDetail?.total_tax);
          }

          let taxAmount = (final_amount * +tax_per) / 100;
          if (+tax?.taxInfo?.tax_type === 2) {
            taxAmount = +tax?.taxInfo?.tax_rate * charge_less_detail.night;
          }
          // console.log(taxAmount,final_amount, "taxAmount");
          bookingTaxDetails.push({
            id: tax?.id,
            amount: +taxAmount.toFixed(2),
          });
        });

        let addons = item?.oneNightAddonList?.map((addon) => ({
          ...addon,
          amount: +(+addon?.amount * +charge_less_detail.night).toFixed(2),
        }));
        let packages = bookingInfo?.bookingPackages;
        let packageLists = [];
        for (let k in packages) {
          const chargeType = +packages[k]?.charge_type;
          let totalAmount = 0;
          let by_date = [];
          if (chargeType === 1) {
            for (let d = 0; d < +charge_less_detail.night; d++) {
              const date = moment(bookingInfo?.checkin_date)
                .add(d, "days")
                .format("YYYY-MM-DD");
              by_date.push({
                date: date,
                unit_price: packages[k].unit_price,
                quantity: 1,
                total_amount: packages[k].unit_price,
                charge_type: packages[k].charge_type,
              });
            }
          } else if (chargeType === 2) {
            totalAmount = Number(packages[k].unit_price);
            by_date.push({
              date: bookingInfo?.checkin_date,
              unit_price: Number(packages[k].unit_price),
              quantity: 1,
              total_amount: totalAmount,
              charge_type: packages[k].charge_type,
            });
          } else {
            totalAmount =
              (+item.no_of_extra_adults +
                +item.no_of_adults +
                +item.no_of_extra_children +
                +item.no_of_children) *
              Number(packages[k].unit_price);
            by_date.push({
              date: bookingInfo?.checkin_date,
              unit_price: Number(packages[k].unit_price),
              quantity:
                +item.no_of_extra_adults +
                +item.no_of_adults +
                +item.no_of_extra_children +
                +item.no_of_children,
              total_amount: totalAmount,
              charge_type: packages[k].charge_type,
            });
          }

          packageLists.push({
            name: packages[k].name,
            // amount: packages[k].price,
            id: packages[k].id,
            unit_price: packages[k].unit_price,
            total_amount: totalAmount,
            charge_type: packages[k].charge_type,
            by_date: by_date,
          });
        }

        bookingItemsTable.push({
          id: item?.id,
          discount_type: 1,
          discount_percentage: +discountPercentage.toFixed(2),
          discount: +total_discount.toFixed(2),
          total_discount: +total_discount.toFixed(2),
          subtotal: +sub_total?.toFixed(2),
          final_amount: +final_amount?.toFixed(2),
          rooms_total: +rooms_total?.toFixed(2),
          tax_detail: bookingTaxDetails,
          addons: addons,
          packageList: packageLists,
        });
      });

      let rooms_sub_total = bookingItemsTable?.reduce(
        (sum, item) => sum + +item?.rooms_total,
        0,
      );
      let total_discount = bookingItemsTable?.reduce(
        (sum, item) => sum + +item?.total_discount,
        0,
      );
      let final_sub_total = +(
        bookingItemsTable?.reduce((sum, item) => sum + item.subtotal, 0) +
        bookingItemInfo?.reduce((sum, item) => sum + item.oneNightAddon, 0) *
          +charge_less_detail?.night +
        +bookingItemInfo?.reduce((sum, item) => sum + item.packagePerNight, 0) *
          +charge_less_detail?.night +
        +bookingItemInfo?.reduce((sum, item) => sum + item.packageOneTime, 0)
      )?.toFixed(2);
      let total_tax = +(
        (final_sub_total * charge_less_detail?.tax_percentage) / 100 +
        charge_less_detail?.tax_flat * +charge_less_detail?.night
      ).toFixed(2);

        let oldCaptureSubTotal =   +(
        (bookingItemInfo?.reduce(
          (sum, item) =>
            sum +
            getSubTotal(
              item.roomRateDetail,
              +charge_less_detail?.night,
              item.no_of_extra_adults,
              item.no_of_extra_children,
              item.discountPercentage,
            ),
          0,
        ) )
      ) +
      bookingItemInfo?.reduce((sum, item) => sum + item.oneNightAddon, 0) *
        +charge_less_detail?.night +
      +bookingItemInfo?.reduce((sum, item) => sum + item.packagePerNight, 0) *
        +charge_less_detail?.night +
      +bookingItemInfo?.reduce((sum, item) => sum + item.packageOneTime, 0); 
      let reedemed_reward_value = +((+bookingItemInfo?.[0]?.total_redeem_value * +oldCaptureSubTotal)/+bookingItemInfo?.[0]?.final_amount).toFixed(2);


      let oldFinalAmount =
        bookingItemInfo?.reduce(
          (sum, item) =>
            sum +
            getSubTotal(
              item.roomRateDetail,
              +charge_less_detail.night,
              item.no_of_extra_adults,
              item.no_of_extra_children,
              item.discountPercentage,
            ),
          0,
        ) +
        charge_less_detail?.night *
          bookingItemInfo?.reduce((sum, item) => sum + item.oneNightAddon, 0) +
        +charge_less_detail?.night *
          bookingItemInfo?.reduce(
            (sum, item) => sum + item.packagePerNight,
            0,
          ) +
        +bookingItemInfo?.reduce((sum, item) => sum + item.packageOneTime, 0) - 
        +reedemed_reward_value
        +
        ((bookingItemInfo?.reduce(
          (sum, item) =>
            sum +
            getSubTotal(
              item.roomRateDetail,
              +charge_less_detail.night,
              item.no_of_extra_adults,
              item.no_of_extra_children,
              item.discountPercentage,
            ),
          0,
        ) +
          charge_less_detail?.night *
            bookingItemInfo?.reduce(
              (sum, item) => sum + item.oneNightAddon,
              0,
            ) +
          +charge_less_detail?.night *
            bookingItemInfo?.reduce(
              (sum, item) => sum + item.packagePerNight,
              0,
            ) +
          +bookingItemInfo?.reduce(
            (sum, item) => sum + item.packageOneTime,
            0,
          ) -
         +reedemed_reward_value
        ) *
          charge_less_detail?.tax_percentage) /
          100 +
        charge_less_detail?.tax_flat * +charge_less_detail?.night;
       

      let folio_discount = +(
        // oldFinalAmount 
        // // bookingInfo?.final_amount
        // - +charge_less_detail?.final_capture_amount  
        (+total_discount - (+reedemed_reward_value - +charge_less_detail?.reedemed_reward_value)) +
        ((+total_discount - (+reedemed_reward_value - +charge_less_detail?.reedemed_reward_value))
        * charge_less_detail?.tax_percentage /  100)

      
        // - 

      //   ((+bookingInfo?.total_redeem_value - +charge_less_detail?.reedemed_reward_value) + 
      // ((+bookingInfo?.total_redeem_value - +charge_less_detail?.reedemed_reward_value) * charge_less_detail?.tax_percentage) /
      //     100) -
      //   ((+reedemed_reward_value - +charge_less_detail?.reedemed_reward_value) + 
      // ((+reedemed_reward_value - +charge_less_detail?.reedemed_reward_value) * charge_less_detail?.tax_percentage) /
      //     100)
        // - (
        //   +bookingInfo?.total_redeem_value - +charge_less_detail?.reedemed_reward_value
        // )
      ).toFixed(2);

        console.log(folio_discount,
          reedemed_reward_value, 
          +charge_less_detail?.reedemed_reward_value,charge_less_detail?.tax_percentage,"folio_discount")

      let addon_total = bookingItemsTable?.reduce(
        (sum, item) =>
          sum + +item?.addons?.reduce((sumA, { amount }) => sumA + +amount, 0),
        0,
      );
      let package_total = bookingItemInfo?.reduce(
        (sum, item) =>
          sum +
          +(item?.packagePerNight * charge_less_detail?.night) +
          +item?.packageOneTime,
        0,
      );
      bookingTable = {
        rooms_sub_total: rooms_sub_total,
        total_discount: total_discount,
        total_tax: total_tax,
        final_amount: charge_less_detail?.final_capture_amount,
        no_of_days: charge_less_detail?.night,
        folio_discount: folio_discount,
        addon_total: addon_total,
        package_total: package_total,
      };
      const capturedAmount = old_captured_amount;
      if (
        +capturedAmount > +charge_less_detail?.final_capture_amount &&
        +charge_less === 1
      ) {
        let filteredTransaction = bookingInfo?.bookingPaymentSummary?.filter(
          (item) => item?.summary_type === 0 && +item?.transaction_type === 2,
        );

        let refund_amount = +(
          +capturedAmount - +charge_less_detail?.final_capture_amount
        ).toFixed(2);
        if (filteredTransaction?.length < 2) {
          refund_info.push({
            payment_id: filteredTransaction?.[0]?.id,
            amount: refund_amount,
            payment_type: +filteredTransaction?.[0]?.payment_type,
          });
        } else {
          let sum = refund_amount;
          refundSelectedCard?.forEach((item) => {
            let selectedPay = bookingInfo?.bookingPaymentSummary?.find(
              (pay) => pay?.id === item,
            );
            if (selectedPay) {
              if (sum <= 0) {
                return;
              }
              let createRefundAmount = sum;
              if (
                createRefundAmount >
                +selectedPay?.amount - +selectedPay?.refunded_amount
              ) {
                createRefundAmount =
                  +selectedPay?.amount - +selectedPay?.refunded_amount;
              }
              refund_info.push({
                payment_id: selectedPay?.id,
                amount: createRefundAmount,
                payment_type: selectedPay?.payment_type,
              });
              sum = sum - createRefundAmount;
            }
          });
        }
        if (!cashBySysyem) {
          refund_info = refund_info.filter(
            (refun) => refun?.payment_type !== 1,
          );
        }
      }

      if(+bookingInfo?.total_redeem_value !== +charge_less_detail?.reedemed_reward_value){
        if(bookingInfo?.bookingRedemptions?.length < 2){
          let per_point_value = +bookingInfo?.total_redeem_value / +bookingInfo?.bookingRedemptions?.[0]?.redeemed_points;
          let revert_redeem_value = +(
            +charge_less_detail?.reedemed_reward_value
          ).toFixed(2);
          revert_reward_info.push({
            program_id: bookingInfo?.bookingRedemptions?.[0]?.loyalty_program_id,
            redeem_value: revert_redeem_value,
            used_points: +(+revert_redeem_value / +per_point_value).toFixed(2),
          });
        } else {
           let sum =  +charge_less_detail?.reedemed_reward_value;
          rewardRevertValues?.forEach((item) => {
            let selectedPay = bookingInfo?.bookingRedemptions?.find(
              (pay) => pay?.loyalty_program_id === item,
            );
            if (selectedPay) {
              if (sum <= 0) {
                return;
              }
              let createRefundAmount = sum;
              if (
                createRefundAmount >
                +selectedPay?.redeem_value
              ) {
                createRefundAmount =
                  +selectedPay?.redeem_value;
              }
            let per_point_value = +selectedPay?.redeem_value / +selectedPay?.redeemed_points;

               revert_reward_info.push({
            program_id: selectedPay?.loyalty_program_id,
            redeem_value: createRefundAmount,
            used_points: +(+createRefundAmount / +per_point_value).toFixed(2),
          });
                  sum = sum - createRefundAmount;
            }
          })
        }
      } else {
        bookingInfo?.bookingRedemptions?.forEach((redem) => {
          revert_reward_info.push({
            program_id: redem?.loyalty_program_id,
            redeem_value: redem?.redeem_value,
            used_points: redem?.redeemed_points,
          });
        });
      } 
    }



    let is_early_checkout =
      +charge_less === 1 &&
      moment(bookingInfo?.checkin_date, "YYYY-MM-DD")
        ?.add(charge_less_detail?.night, "days")
        ?.format("YYYY-MM-DD") !== bookingInfo?.checkout_date
        ? 1
        : 0;

    let bodyFormData = {
      booking_id: values.booking_id,
      check_out_time: values.check_out_time,
      is_late_check_out: values.is_late_check_out,
      late_check_out_price: values.late_check_out_price,
      send_sms: send_sms,
      is_custom_capture: charge_less,
      final_capture_amount: +charge_less_detail?.final_capture_amount,
      booking_table: bookingTable,
      booking_items_table: bookingItemsTable,
      is_early_checkout: is_early_checkout,
      remark: charge_less_detail?.description,
      refund_info: refund_info,
      redeemed_reward_detail: revert_reward_info,
      redeemed_reward: +charge_less_detail?.reedemed_reward_value || 0,
      is_redeem_changed: +bookingInfo?.total_redeem_value !== +charge_less_detail?.reedemed_reward_value ? 1 : 0,
      // is_revert_reward: is_reward_revert ? 1 : 0,
    };

    // console.log(bodyFormData, 1136);
    // dispatch(getLoadingFailed());

    // return;
    setOpenSendSmsEmailDialog(false);
    const result = await makeCheckOut(bodyFormData);
    if (result?.status === 200) {
      if (print && result?.data?.invoice_copy) {
        window.open(result?.data?.invoice_copy, "_blank");
      }
      dispatch(chargeLessDetailFailed());
      handleDialogClose();
      dispatch(getLoadingFailed());
      refreshData();
      toast.success(t(result.message));
    } else {
      dispatch(getLoadingFailed());
      toast.error(t(result.message));
    }
  };

  const handleConfirm = async (values, send_sms) => {
    setCheckOutValues(values);
    if (charge_less === 1) {
      if (charge_less_detail?.final_capture_amount < 0) {
        toast.error(t("Please Add Charge Amount"));
        return;
      }
      if (charge_less_detail?.description === "") {
        toast.error(t("Please Add Description on less charge amount"));
        return;
      }
    }
    if (charge_less === 1) {
      const capturedAmount = await getCapturedAmount();
      if (+capturedAmount > +charge_less_detail?.final_capture_amount) {
        let filteredTransaction = bookingInfo?.bookingPaymentSummary?.filter(
          (item) => item?.summary_type === 0 && +item?.transaction_type === 2,
        );
        if (filteredTransaction?.length > 1) {
          setOpenCreditCardDialog(true);
        } else if (filteredTransaction?.[0]?.payment_type === 1) {
          setOpenCashRefundDialog(true);
        } else {
          handleOpenSmsEmail(values);
        }
      } else {
        handleOpenSmsEmail(values);
      }
    } else {
      handleOpenSmsEmail(values);
    }
  };

  const handleCashAction = (action) => {
    handleOpenSmsEmail(checkOutValues);
    setCashBySystem(action);
    setOpenCashRefundDialog(false);
  };

  const handleConfirmRefundSelected = () => {
    let sum = 0;
    refundSelectedCard?.forEach((item) => {
      let selectedPay = bookingInfo?.bookingPaymentSummary?.find(
        (pay) => pay?.id === item,
      );
      if (selectedPay) {
        sum = sum + +selectedPay?.amount - +selectedPay?.refunded_amount;
      }
    });
    if (
      sum <
      +(
        +old_captured_amount - +charge_less_detail?.final_capture_amount
      ).toFixed(2)
    ) {
      toast.error("Please select one more payment method");
      return;
    }

    let selectedCash = bookingInfo?.bookingPaymentSummary?.find(
      (item) =>
        refundSelectedCard?.includes(item?.id) && +item?.payment_type === 1,
    );

    if (selectedCash) {
      setOpenCashRefundDialog(true);
      setOpenCreditCardDialog(false);
    } else {
      handleOpenSmsEmail(checkOutValues);
      setOpenCreditCardDialog(false);
    }
  };

  const handleConfirmRewardRevertSelected = () => {
    let sum = 0;
    rewardRevertValues?.forEach((item) => {
      let selectedPay = bookingInfo?.bookingRedemptions?.find(
        (pay) => pay?.loyalty_program_id === item,
      );
      if (selectedPay) {
        sum = sum + +selectedPay?.redeem_value;
      }
    });
    if (
      sum <
      +(
        // +bookingInfo?.total_redeem_value -
        +charge_less_detail?.reedemed_reward_value
      ).toFixed(2)
    ) {
      toast.error("Please select one more to apply reward");
      return;
    }

    handleConfirm(checkOutValues);
    setRewardRevertSelectDialog(false);
  };

  return (
    <div className="p-2" style={{ overflow: "scroll" }}>
      {loading && <Loader />}
      {/* <div
        className="d-flex"
        style={{
          width: "100%",
          minHeight: "50px",
          margin: "auto",
          marginBottom: "0px",
        }}
      >
        <div
          style={{ width: "75%", padding: "10px", alignItems: "center" }}
          className="d-flex"
        >
          {t("Booking")}
        </div>
      </div> */}
      {/* formik start */}
      <Formik
        initialValues={initialState}
        // onSubmit={handleConfirm}
        onSubmit={handleConfirmWithReward}
        // onSubmit={handleOpenSmsEmail}
        validateOnBlur={false}
        validationSchema={CheckOutValidations}
        validateOnChange={true}
        enableReinitialize={true}
      >
        {/* {(errors, touched, props: any) => { */}
        {(props) => {
          const { handleSubmit } = props;
          return (
            <form onSubmit={handleSubmit}>
              <div
                className=""
                style={{
                  width: "100%",
                  minHeight: "100px",
                  border: "1px solid gray",
                  margin: "auto",
                  // padding: "10px",
                }}
              >
                <div className="p-1">
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography
                        variant="h4"
                        style={{
                          marginTop: "15px",
                          marginLeft: "5px",
                          padding: "5px",
                          fontSize: "110%",
                        }}
                      >
                        {t("User Info")}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          // marginRight: "20px",
                          marginBottom: "10px",
                          borderTop: "2px solid",
                          marginTop: "10px",
                        }}
                      ></div>
                    </Grid>
                  </Grid>
                </div>

                <div className="p-1">
                  <Grid container spacing={2}>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Confirmation No")}
                      </Typography>
                      <Typography variant="subtitle1">
                        #{String(bookingInfo?.id).padStart(6, "0")}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Guest")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingInfo?.userData?.name}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Mobile")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.userData?.mobile}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Email")}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{ wordWrap: "break-word" }}
                      >
                        {bookingDetail?.userData?.email}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>

                <div className="p-1">
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography
                        variant="h4"
                        style={{
                          marginTop: "15px",
                          marginLeft: "5px",
                          padding: "5px",
                          fontSize: "110%",
                        }}
                      >
                        {t("Booking Info")}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          // marginRight: "20px",
                          marginBottom: "10px",
                          borderTop: "2px solid",
                          marginTop: "10px",
                        }}
                      ></div>
                    </Grid>
                  </Grid>
                </div>
                <div className="p-1">
                  <Grid container spacing={2}>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Booking Date")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.booking_date}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Check In Date")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.checkin_date}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Check Out Date")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.checkout_date}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Booking Status")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {t(bookingDetail?.bookingStatusInfo?.status)}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("No. Of Days")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.no_of_days}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("IATA No")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.iata_number}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Payment Type")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {t(getPaymentTypeOfBooking(bookingDetail.payment_type))}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Booking Type")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail.booking_type === 1
                          ? t("Single")
                          : t("Group")}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Total Addon Amount")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail.total_addon_amount}
                      </Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Total Discount Amount")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.total_discount}
                      </Typography>
                    </Grid>
                    {+bookingDetail?.total_redeem_value > 0 && (
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Total Redeemed Reward")}
                      </Typography>
                      <Typography variant="subtitle1">
                        ${Number(+bookingDetail?.total_redeem_value).toFixed(2)}
                      </Typography>
                    </Grid>)}
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Final Booking Amount")}
                      </Typography>
                      <Typography variant="subtitle1">
                        {bookingDetail?.final_amount}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>

                <div className="p-1">
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography
                        variant="h4"
                        style={{
                          marginTop: "15px",
                          marginLeft: "5px",
                          padding: "5px",
                          fontSize: "110%",
                        }}
                      >
                        {t("Booking Item Info")}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          // marginRight: "20px",
                          marginBottom: "10px",
                          borderTop: "2px solid",
                          marginTop: "10px",
                        }}
                      ></div>
                    </Grid>
                  </Grid>
                </div>

                <div className="p-1">
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TableContainer>
                        <Table
                          borderAxis="both"
                          sx={{
                            borderCollapse: "collapse",
                            minWidth: "650px",
                          }}
                        >
                          <TableHead>
                            <TableRow sx={{ overflowWrap: "anywhere" }}>
                              <>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="5%"
                                >
                                  <Typography variant="h4"> {"#"}</Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="15%"
                                >
                                  <Typography variant="h4">
                                    {t("Room Info")}
                                  </Typography>{" "}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="20%"
                                >
                                  <Typography variant="h4">
                                    {t("People Counts")}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="25%"
                                >
                                  <Typography variant="h4">
                                    {t("Room Price")}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="15%"
                                >
                                  <Typography variant="h4">
                                    {t("Discount")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="10%"
                                >
                                  <Typography variant="h4">
                                    {t("Final Amount")}
                                  </Typography>
                                </TableCell>
                              </>
                            </TableRow>
                          </TableHead>

                          {bookingDetail?.bookingItemsData?.length > 0
                            ? bookingDetail?.bookingItemsData?.map(
                                (data, index) => {
                                  return data.roomCategoryDetail
                                    ?.roomcategory_name !== "" ? (
                                    <TableBody key={index}>
                                      <TableRow>
                                        <>
                                          <TableCell
                                            sx={{
                                              padding: "10px 5px",
                                              borderTop: "1px solid #B4ADAD",
                                              whiteSpace: "wrap",
                                            }}
                                            className="text-center"
                                          >
                                            {index + 1}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              padding: "10px 5px",
                                              borderTop: "1px solid #B4ADAD",
                                              whiteSpace: "wrap",
                                            }}
                                            className="text-center"
                                          >
                                            <p>
                                              {t("Type")}:{" "}
                                              {
                                                data.roomCategoryDetail
                                                  ?.roomcategory_name
                                              }
                                            </p>
                                            <p>
                                              {t("Stay code")}:{" "}
                                              {data.share_code}
                                            </p>
                                            <p>{data.room_no}</p>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              padding: "10px 5px",
                                              borderTop: "1px solid #B4ADAD",
                                              whiteSpace: "wrap",
                                            }}
                                            className="text-center"
                                          >
                                            <p>
                                              {t("No of Adults")}
                                              {" - "}
                                              {data.no_of_adults}
                                            </p>
                                            <p>
                                              {t("No of Children")}
                                              {" - "}
                                              {data.no_of_children}
                                            </p>
                                            <p>
                                              {t("No of Pets")}
                                              {" - "}
                                              {data.no_of_pets}
                                            </p>
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              padding: "10px 5px",
                                              borderTop: "1px solid #B4ADAD",
                                              whiteSpace: "wrap",
                                            }}
                                            className="text-center"
                                          >
                                            {data.room_price}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              padding: "10px 5px",
                                              borderTop: "1px solid #B4ADAD",
                                              whiteSpace: "wrap",
                                            }}
                                            className="text-center"
                                          >
                                            <p>{t("Add On")}:</p>

                                            {data?.bookingAddonDetail?.length >
                                              0 &&
                                              data?.bookingAddonDetail?.map(
                                                (addon, ainx) => {
                                                  return (
                                                    <p key={ainx}>
                                                      {addon.addonDetail?.name}
                                                      {" - "}
                                                      {addon.amount}
                                                    </p>
                                                  );
                                                },
                                              )}
                                            {data?.bookingAddonDetail?.length >
                                            0 ? (
                                              <p
                                                style={{
                                                  borderTop: "2px solid",
                                                }}
                                              >
                                                {t("Total")}-{data.addon_total}
                                              </p>
                                            ) : (
                                              <p>{t("Total")}-0.00</p>
                                            )}
                                            <p>{t("Discount")}:</p>
                                            <p>{data.discount}</p>
                                          </TableCell>

                                          <TableCell
                                            sx={{
                                              padding: "10px 5px",
                                              borderTop: "1px solid #B4ADAD",
                                              whiteSpace: "wrap",
                                            }}
                                            className="text-center"
                                          >
                                            {data.final_amount}
                                          </TableCell>
                                        </>
                                      </TableRow>
                                    </TableBody>
                                  ) : null;
                                },
                              )
                            : null}
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </div>
                <div className="p-1">
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography
                        variant="h4"
                        style={{
                          marginTop: "15px",
                          marginLeft: "5px",
                          padding: "5px",
                          fontSize: "110%",
                        }}
                      >
                        {t("Sales Item Info")}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          // marginRight: "20px",
                          marginBottom: "10px",
                          borderTop: "2px solid",
                          marginTop: "10px",
                        }}
                      ></div>
                    </Grid>
                  </Grid>
                </div>

                <div className="p-1">
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TableContainer>
                        <Table
                          borderAxis="both"
                          sx={{
                            borderCollapse: "collapse",
                            minWidth: "650px",
                          }}
                        >
                          <TableHead>
                            <TableRow sx={{ overflowWrap: "anywhere" }}>
                              <>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="5%"
                                >
                                  <Typography variant="h4"> {"#"}</Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="30%"
                                >
                                  <Typography variant="h4">
                                    {" "}
                                    {t("Product Name")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="10%"
                                >
                                  <Typography variant="h4">
                                    {"Price"}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="10%"
                                >
                                  <Typography variant="h4">
                                    {" "}
                                    {t("Quantity")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="15%"
                                >
                                  <Typography variant="h4">
                                    {" "}
                                    {t("Discount")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="10%"
                                >
                                  <Typography variant="h4">
                                    {" "}
                                    {t("Sub Total")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  width="10%"
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {" "}
                                    {t("AddOn Total")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  className="text-center"
                                  width="10%"
                                >
                                  {" "}
                                  <Typography variant="h4">
                                    {t("Final Amount")}{" "}
                                  </Typography>
                                </TableCell>
                              </>
                            </TableRow>
                          </TableHead>

                          {salesItemInfo?.length > 0
                            ? salesItemInfo?.map((data, index) => {
                                return data.name !== "" ? (
                                  <TableBody key={index}>
                                    <TableRow>
                                      <>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          {data?.index}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          {data?.name}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          {data.price}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          {data.quantity}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          <span
                                            style={{
                                              width: "50px",
                                              height: "20px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {data.discount}
                                          </span>
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          {data.sub_total}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          {data.addon_total}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding:
                                              data?.index !== ""
                                                ? "10px!important"
                                                : "2px 10px!important",
                                            fontWeight:
                                              data?.index !== ""
                                                ? "600!important"
                                                : "",
                                            whiteSpace: "wrap",
                                            borderTop:
                                              data?.index !== ""
                                                ? "1px solid  #B4ADAD"
                                                : "0px",
                                          }}
                                          className="text-center"
                                        >
                                          {data.total}
                                        </TableCell>
                                      </>
                                    </TableRow>
                                  </TableBody>
                                ) : null;
                              })
                            : null}
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </div>
              </div>
              <div
                className="d-block"
                style={{
                  width: "100%",
                  minHeight: "60px",
                  margin: "auto",
                  border: "1px solid gray",
                  // padding: "10px",
                  marginTop: "20px",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    marginTop: "15px",
                    marginLeft: "5px",
                    padding: "5px",
                    fontSize: "110%",
                  }}
                >
                  {t("Folio Info")}
                </Typography>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    // marginRight: "20px",
                    marginBottom: "10px",
                    borderTop: "2px solid",
                    marginTop: "10px",
                  }}
                ></div>

                <div>
                  <div
                    className="nav-header"
                    style={{
                      display: "flex",
                      color: "gray",
                      fontSize: "20px",

                      height: "50px",
                    }}
                  >
                    {folioData?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          onClick={() => handleTabs(index)}
                          className={`nav-tab text-16 ${
                            tab === index ? "active-tab" : ""
                          }`}
                        >
                          <Typography variant="h4">{t(item.name)}</Typography>
                        </div>
                      );
                    })}
                  </div>

                  {folioData?.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        {tab === index && (
                          <div className="p-1">
                            <div
                              key={index}
                              style={{
                                marginTop: "10px",
                                // marginLeft: "10px",
                                width: "100%",
                                border: "0px solid black",
                              }}
                            >
                              <TableContainer>
                                <Table
                                  borderAxis="both"
                                  sx={{
                                    borderCollapse: "collapse",
                                    minWidth: "650px",
                                  }}
                                >
                                  <TableHead>
                                    <TableRow>
                                      <>
                                        <TableCell
                                          className="text-center"
                                          width="50"
                                        >
                                          <Typography variant="h4">
                                            {" "}
                                            {t("#Item")}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          className="text-center"
                                          width="50"
                                        >
                                          <Typography variant="h4">
                                            {t("Date")}
                                          </Typography>
                                        </TableCell>

                                        <TableCell
                                          className="text-center"
                                          width="50"
                                        >
                                          <Typography variant="h4">
                                            {t("Description")}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          className="text-center"
                                          width="50"
                                        >
                                          <Typography variant="h4">
                                            {t("Comment")}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          className="text-center"
                                          width="50"
                                        >
                                          <Typography variant="h4">
                                            {t("Amount")}
                                          </Typography>
                                        </TableCell>
                                      </>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {item.folioDetail?.length > 0
                                      ? item.folioDetail
                                          ?.slice() // to avoid mutating original array
                                          .sort((a, b) =>
                                            moment(a.date).diff(moment(b.date)),
                                          ) // sort by `date`
                                          .map((data, idx) => {
                                            return (
                                              <TableRow key={idx}>
                                                <>
                                                  <TableCell className="text-center">
                                                    {++idx}
                                                  </TableCell>
                                                  <TableCell className="text-center">
                                                    {moment(
                                                      data.date,
                                                      "YYYY-MM-DD",
                                                    ).format("MM/DD/YYYY")}
                                                  </TableCell>

                                                  <TableCell className="text-center">
                                                    {t(data.description)}
                                                  </TableCell>
                                                  <TableCell className="text-center">
                                                    {data.comment}
                                                  </TableCell>
                                                  <TableCell className="text-center">
                                                    {data.payment_credited_debited ===
                                                    1
                                                      ? `(${data.amount})`
                                                      : data.payment_credited_debited ===
                                                          3
                                                        ? ""
                                                        : // `[${data?.amount}]`
                                                          data.amount}
                                                  </TableCell>
                                                </>
                                              </TableRow>
                                            );
                                          })
                                      : null}
                                    <TableRow>
                                      <>
                                        <TableCell className="text-center"></TableCell>
                                        <TableCell className="text-center"></TableCell>
                                        <TableCell className="text-center"></TableCell>
                                        {/* <TableCell className="text-center"></TableCell> */}
                                        <TableCell className="text-center">
                                          <Typography
                                            style={{ textAlign: "right" }}
                                            variant="h4"
                                          >
                                            {t("Balance")}
                                          </Typography>
                                        </TableCell>
                                        <TableCell className="text-center">
                                          {item.balance > 0
                                            ? `(${item.balance})`
                                            : item.balance}
                                        </TableCell>
                                      </>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </div>
                        )}
                      </Fragment>
                    );
                  })}
                </div>
              </div>
              <div
                className="d-flex"
                style={{
                  width: "100%",
                  minHeight: "120px",
                  border: "1px solid gray",
                  margin: "auto",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    padding: "10px",
                    alignItems: "center",
                  }}
                  className="d-block"
                >
                  <h6>
                    {t("Check Out Time")} -{" "}
                    {moment(bookingInfo?.checkout_date, "YYYY-MM-DD").format(
                      "MM/DD/YYYY",
                    )}
                  </h6>
                  {/* <h6>{bookingInfo?.checkout_date}</h6> */}

                  <Grid container spacing={2} alignItems="end">
                    <Grid item lg={4}>
                      <Field
                        label=""
                        name="check_out_time"
                        type="time"
                        defaultoption="true"
                        component={FormikInput1}
                      />
                      {props.errors.check_out_time &&
                      props.touched.check_out_time ? (
                        <div style={{ color: "red" }}>
                          {props.errors.check_out_time}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </div>
              </div>

              <div
                // className="d-flex"
                style={{
                  width: "100%",
                  border: "1px solid gray",
                  margin: "auto",
                }}
              >
                <Grid container className="pl-1" spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography
                      variant="h4"
                      style={{
                        marginTop: "15px",
                        // marginLeft: "5px",
                        padding: "5px",
                        fontSize: "110%",
                      }}
                    >
                      {t("Split Bill")}
                    </Typography>
                  </Grid>
                </Grid>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    // marginRight: "20px",
                    marginBottom: "10px",
                    borderTop: "2px solid",
                    marginTop: "10px",
                  }}
                ></div>
                <Grid container className="pl-1" spacing={2}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="mb-1"
                    style={
                      {
                        // marginTop: "-5px",
                      }
                    }
                  >
                    <FormGroup style={{ width: "fit-content" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={(e) => {
                              const { checked } = e.target;
                              if (checked) {
                                setSplit_Bill(1);
                                setGuest_count([]);
                                setGuests_count([]);
                                props.setFieldValue(`split_bill`, 1);
                              } else {
                                setSplit_Bill(0);
                                setGuest_count([]);
                                setGuests_count([]);
                                setFinal_amount(bookingDetail?.final_amount);
                                props.setFieldValue(`split_bill`, 0);
                              }
                            }}
                          />
                        }
                        label={t("Do you want a split bill?")}
                      />
                    </FormGroup>
                  </Grid>
                </Grid>

                {split_bill === 1 && (
                  <Grid className="pl-1 pt-1 mb-2 pr-3" container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography
                        style={{
                          color: "rgb(63 69 85)",
                          fontSize: "16px",
                          lineHeight: "24px",
                          marginBottom: "11px",
                        }}
                      >
                        {t("How many people to split the bill?")}
                      </Typography>
                      <TextField
                        placeholder={t("Enter Guest Count")}
                        type="number"
                        min={0}
                        value={guests_count}
                        onChange={(e) => {
                          handleGuestCount(e, props.setFieldValue);
                        }}
                        variant="outlined"
                      />
                      {/* <Field
                            label="How many people to split the bill?"
                            name="guest_count"
                            // type="number"
                            onChange={(e) => {
                              handleGuestCount(e, props.setFieldValue);
                            }}
                            component={FormikInput1}
                          /> */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Typography
                        style={{
                          marginBottom: "10px",
                          color: "rgb(63 69 85)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        {t("Pending Amount")}
                      </Typography>
                      <TextField
                        disabled
                        value={final_amount}
                        variant="outlined"
                      />
                      {/* <Field
                            label="Price"
                            name="final_amounts"
                            id="final_amounts"
                            readOnly
                            component={FormikInput1}
                          /> */}
                    </Grid>
                    {guest_count.length > 0 &&
                      guest_count?.map((items, index) => (
                        <Grid
                          className="pl-2 pt-1 mb-2"
                          container
                          key={index}
                          spacing={2}
                        >
                          <Grid item xs={12} sm={4}>
                            <Typography
                              style={{
                                marginBottom: "11px",
                                color: "rgb(63 69 85)",
                                fontSize: "16px",
                                lineHeight: "24px",
                              }}
                            >
                              {t("Guest")} {index + 1}
                            </Typography>
                            <Autocomplete
                              // disablePortal
                              id="combo-box-demo"
                              size="small"
                              name={`guest_split.${index}.guest`}
                              options={searchUserResult}
                              onInputChange={onSearchInputChange}
                              getOptionLabel={(option) => option?.label || ""}
                              onChange={(e, value) => {
                                getCradsDetail(
                                  e,
                                  value,
                                  index,
                                  props.setFieldValue,
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={`Guest ${index + 1}`}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <Typography
                              style={{
                                marginBottom: "11px",
                                color: "rgb(63 69 85)",
                                fontSize: "16px",
                                lineHeight: "24px",
                              }}
                            >
                              {t("Amount")}
                            </Typography>
                            <TextField
                              name={`guest_split.${index}.amount`}
                              type="number"
                              placeholder={t("Enter Amount")}
                              inputProps={{
                                step: "0.01", // ✅ ensures decimals like 684.71 are allowed
                              }}
                              onChange={(e) => {
                                handleGuestAmount(
                                  e,
                                  index,
                                  props.setFieldValue,
                                );
                              }}
                              value={props?.value?.guest_split[index]?.amount}
                              variant="outlined"
                            />
                            {/* <Field
                                  name={`guest_split.${index}.amount`}
                                  label="Amount"
                                  type="number"
                                  placeHolder="Enter Amount"
                                  onChange={(e) => { handleGuestAmount(e, index, props.setFieldValue) }}
                                  component={FormikInput1}
                                /> */}
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <Typography
                              style={{
                                marginBottom: "11px",
                                color: "rgb(63 69 85)",
                                fontSize: "16px",
                                lineHeight: "24px",
                              }}
                            >
                              {t("Payment Type")}
                            </Typography>
                            <Select
                              fullWidth
                              name={`guest_split.${index}.payment_type`}
                              onChange={(e) => {
                                handlePaymentType(
                                  e,
                                  index,
                                  props.setFieldValue,
                                );
                              }}
                              defaultValue={0}
                            >
                              <MenuItem value={0}>
                                -- {t("Select Payment Type")} --
                              </MenuItem>
                              {paymentType.map((item, index) => (
                                <MenuItem value={item.id} key={item.id}>
                                  {t(item.name)}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>
                          {props.values?.guest_split[index]?.payment_type ===
                            2 && (
                            <Grid item xs={1.5}>
                              <Typography
                                style={{
                                  marginBottom: "11px",
                                  color: "rgb(63 69 85)",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Card Present")}
                              </Typography>
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    sx={{ m: 1 }}
                                    checked={
                                      props.values?.guest_split[index]
                                        ?.card_present
                                    }
                                    onChange={(e) => {
                                      handleCardPresent(
                                        e,
                                        index,
                                        props.setFieldValue,
                                      );
                                    }}
                                  />
                                }
                                label={""}
                              />
                            </Grid>
                          )}

                          {props.values?.guest_split[index]?.payment_type ===
                            1 && (
                            <Grid
                              container
                              spacing={2}
                              style={{
                                marginLeft: "20px",
                                border: "2px solid #B4ADAD",
                                borderRadius: "5px",
                                width: "97%",
                                marginTop: "25px",
                                padding: "20px",
                                height: "fit-content",
                              }}
                            >
                              {props?.values?.guest_split[index]?.pay === 0 &&
                              props.values?.guest_split[index]?.payment_type ===
                                1 ? (
                                <Button
                                  variant="contained"
                                  onClick={(e) => {
                                    payNow(
                                      e,
                                      index,
                                      props.setFieldValue,
                                      items,
                                      props.values.guest_split[`${index}`][
                                        "guest"
                                      ],
                                      props.values.guest_split[`${index}`][
                                        "payment_card_detail"
                                      ],
                                      props.values.guest_split[`${index}`][
                                        "payment_cheque_detail"
                                      ],
                                      props.values.guest_split[`${index}`][
                                        "amount"
                                      ],
                                      props.values.guest_split[`${index}`][
                                        "payment_type"
                                      ],
                                      props.values.guest_split[`${index}`][
                                        "card_present"
                                      ],
                                      props.values.guest_split[`${index}`][
                                        "card_verify_token"
                                      ],
                                    );
                                  }}
                                  // style={{
                                  //   height: "47px",
                                  //   marginTop: "23px",
                                  // }}
                                  className="comman-button"
                                >
                                  {t("Pay Now")}
                                </Button>
                              ) : null}
                            </Grid>
                          )}

                          {props.values?.guest_split[index]?.card_present ===
                            0 &&
                            props.values?.guest_split[index]?.payment_type ===
                              2 && (
                              <Grid
                                container
                                spacing={2}
                                style={{
                                  marginLeft: "20px",
                                  border: "2px solid #B4ADAD",
                                  borderRadius: "5px",
                                  width: "97%",
                                  marginTop: "25px",
                                  height: "auto",
                                  paddingBottom: "10px",
                                  paddingRight: "10px",
                                  justifyItems: "flex-end",
                                }}
                              >
                                {!props.values?.guest_split[index]?.suOn && (
                                  <>
                                    <Grid item lg={2} md={4} sm={12} xs={12}>
                                      <Typography
                                        id="font-600"
                                        style={{
                                          marginBottom: "11px",
                                          color: "rgb(30, 30, 30)",
                                          fontSize: "16px",
                                          lineHeight: "24px",
                                        }}
                                      >
                                        {t("Select Card")}
                                      </Typography>
                                      <Select
                                        fullWidth
                                        name={`guest_split.${index}.payment_card_detail.id`}
                                        value={
                                          guest_count[index]
                                            ?.payment_card_detail?.id
                                        }
                                        onChange={(e) => {
                                          handleCardDetail(
                                            e,
                                            index,
                                            props.setFieldValue,
                                          );
                                        }}
                                        defaultValue={0}
                                      >
                                        <MenuItem value={0}>Add Card</MenuItem>
                                        {props?.values?.guest_split[
                                          index
                                        ]?.payment_card?.map((item, index) => (
                                          <MenuItem
                                            key={item?.id}
                                            value={item.id}
                                          >
                                            {t(item.card_holder_name)}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </Grid>
                                    <Grid item lg={2.5} md={4} sm={6} xs={12}>
                                      <Field
                                        placeHolder={t(
                                          "Enter Card Holder Name",
                                        )}
                                        disabled={
                                          guest_count[index]
                                            ?.payment_card_detail?.id === 0
                                            ? false
                                            : true
                                        }
                                        name={`guest_split.${index}.payment_card_detail.card_holder_name`}
                                        label={t("Card Holder Name")}
                                        component={FormikInput1}
                                      />
                                    </Grid>
                                    <Grid item lg={3} md={4} sm={6} xs={12}>
                                      <Field
                                        placeHolder="Enter Card Number"
                                        disabled={
                                          guest_count[index]
                                            ?.payment_card_detail?.id === 0
                                            ? false
                                            : true
                                        }
                                        name={`guest_split.${index}.payment_card_detail.card_number`}
                                        label={t("Card Number")}
                                        type="text" // Change from "number" to "text"
                                        inputMode="numeric" // Ensures only numbers show up in the keyboard
                                        component={FormikInput1}
                                        onChange={(e) => {
                                          const value = e.target.value.replace(
                                            /\D/g,
                                            "",
                                          ); // Remove non-numeric characters
                                          if (value?.length > 16) {
                                            return;
                                          }
                                          props?.setFieldValue(
                                            `guest_split.${index}.payment_card_detail.card_number`,
                                            value,
                                          );
                                        }}
                                      />
                                    </Grid>
                                    {/* <Grid item lg={1} sm={6} xs={12}>
                                  <Field
                                    placeHolder="MM"
                                    disabled={
                                      guest_count[index]?.payment_card_detail
                                        ?.id === 0
                                        ? false
                                        : true
                                    }
                                    name={`guest_split.${index}.payment_card_detail.mm`}
                                    label={t("Expiry")}
                                    component={FormikInput1}
                                  />
                                </Grid>
                                <Grid item lg={1} sm={6} xs={12}>
                                  <Typography
                                    style={{
                                      marginBottom: "23px",
                                      color: "rgb(30, 30, 30)",
                                      fontSize: "16px",
                                      lineHeight: "24px",
                                    }}
                                  >
                                    {" "}
                                  </Typography>
                                  <Field
                                    type="number"
                                    placeHolder="YYY"
                                    disabled={
                                      guest_count[index]?.payment_card_detail
                                        ?.id === 0
                                        ? false
                                        : true
                                    }
                                    name={`guest_split.${index}.payment_card_detail.yyy`}
                                    component={FormikInput1}
                                  />
                                </Grid> */}
                                    <Grid item lg={1.2} md={4} xs={12}>
                                      <Typography
                                        id="font-600"
                                        style={{
                                          marginBottom: "11px",
                                          color: "rgb(30, 30, 30)",
                                          fontSize: "16px",
                                          lineHeight: "24px",
                                        }}
                                      >
                                        {t("Expiry")}
                                      </Typography>
                                      <FormControl fullWidth>
                                        <InputLabel title={"Month"}>
                                          {"MM"}
                                        </InputLabel>
                                        <Select
                                          name="mm"
                                          input={<OutlinedInput label="MM" />}
                                          label="Month"
                                          disabled={
                                            guest_count[index]
                                              ?.payment_card_detail?.id === 0
                                              ? false
                                              : true
                                          }
                                          onChange={(e) => {
                                            props?.setFieldValue(
                                              `guest_split.${index}.payment_card_detail.mm`,
                                              e.target?.value,
                                            );
                                          }}
                                          value={
                                            props?.values?.guest_split[index]
                                              .payment_card_detail.mm
                                          }
                                        >
                                          <MenuItem value={""}>
                                            {t("MM")}
                                          </MenuItem>
                                          {month.map((item) => (
                                            <MenuItem key={item} value={item}>
                                              {item}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <Grid item lg={1.5} md={4} xs={12}>
                                      <Typography
                                        style={{
                                          marginBottom: "35px",
                                          color: "rgb(30, 30, 30)",
                                          fontSize: "16px",
                                          lineHeight: "24px",
                                        }}
                                      >
                                        {" "}
                                      </Typography>

                                      <FormControl fullWidth>
                                        <InputLabel title={"Year"}>
                                          {"YYYY"}
                                        </InputLabel>
                                        <Select
                                          name="yyy"
                                          input={<OutlinedInput label="YYYY" />}
                                          label={t("Year")}
                                          disabled={
                                            guest_count[index]
                                              ?.payment_card_detail?.id === 0
                                              ? false
                                              : true
                                          }
                                          onChange={(e) => {
                                            props?.setFieldValue(
                                              `guest_split.${index}.payment_card_detail.yyy`,
                                              e.target?.value,
                                            );
                                          }}
                                          value={
                                            props?.values?.guest_split?.[index]
                                              ?.payment_card_detail.yyy
                                          }
                                        >
                                          <MenuItem value={""}>
                                            {t("YYYY")}
                                          </MenuItem>
                                          {yearList.map((item) => (
                                            <MenuItem key={item} value={item}>
                                              {item}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    {guest_count[index]?.payment_card_detail
                                      ?.id === 0 ? (
                                      <Grid item lg={1.8} md={4} xs={12}>
                                        <Field
                                          placeHolder="Enter CVV"
                                          name={`guest_split.${index}.payment_card_detail.cvv`}
                                          label={t("Security Code")}
                                          component={FormikInput1}
                                        />
                                      </Grid>
                                    ) : (
                                      <Grid item lg={1.8} md={4} xs={12}>
                                        <Field
                                          placeHolder={t("Card Type")}
                                          disabled={
                                            guest_count[index]
                                              ?.payment_card_detail?.id === 0
                                              ? false
                                              : true
                                          }
                                          name={`guest_split.${index}.payment_card_detail.card_type`}
                                          label={t("Card Type")}
                                          component={FormikInput1}
                                        />
                                      </Grid>
                                    )}

                                    {guest_count[index]?.payment_card_detail
                                      ?.id === 0 && (
                                      <Grid item lg={3} sm={6} xs={12}>
                                        <Button
                                          variant="contained"
                                          onClick={() => {
                                            addCardDetail(
                                              index,
                                              props.setFieldValue,
                                              props.values.guest_split[
                                                `${index}`
                                              ]["guest"],
                                              props.values.guest_split[
                                                `${index}`
                                              ]["payment_card_detail"],
                                            );
                                          }}
                                          // sx={{
                                          //   // height: "47px",
                                          //   marginTop: {sm: "35px",xs:"0", md: "0"},
                                          // }}
                                          className="comman-button"
                                        >
                                          {t("Add & Verify")}
                                        </Button>
                                      </Grid>
                                    )}
                                  </>
                                )}

                                {props.values?.guest_split[index]?.suToken && (
                                  <>
                                    <Grid item lg={12} md={12}></Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      lg={2}
                                      // style={{ left: "20px" }}
                                      // className="mt-2"
                                    >
                                      <Typography
                                        id="font-600"
                                        style={{
                                          marginBottom: "11px",
                                          color: "rgb(30, 30, 30)",
                                          fontSize: "16px",
                                          lineHeight: "24px",
                                        }}
                                      >
                                        {t("Virtual card token")}
                                      </Typography>
                                      <FormControlLabel
                                        control={
                                          <IOSSwitch
                                            sx={{ m: 1 }}
                                            disabled={
                                              +props.values?.guest_split[index]
                                                ?.pay === 1
                                            }
                                            checked={
                                              props.values?.guest_split[index]
                                                ?.suOn
                                            }
                                            onChange={(e) =>
                                              handleSuOn(
                                                e,
                                                index,
                                                props?.setFieldValue,
                                                props?.values,
                                              )
                                            }
                                          />
                                        }
                                        label={""}
                                      />
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                      <Typography
                                        id="font-600"
                                        style={{
                                          marginBottom: "11px",
                                          color: "rgb(30, 30, 30)",
                                          fontSize: "16px",
                                          lineHeight: "24px",
                                        }}
                                      >
                                        {t("Token Number")}
                                      </Typography>
                                      <TextField
                                        value={String(
                                          props.values?.guest_split[
                                            index
                                          ]?.suToken?.substr(
                                            props.values?.guest_split[index]
                                              ?.suToken?.length - 4,
                                          ),
                                        ).padStart(12, "x")}
                                        placeholder={t("Card Number")}
                                        disabled
                                        id="su_token"
                                      />
                                    </Grid>
                                  </>
                                )}
                                <Grid item lg={2}>
                                  {/* <Typography
                                    style={{
                                      marginBottom: "11px",
                                      color: "rgb(30, 30, 30)",
                                      fontSize: "16px",
                                      lineHeight: "24px",
                                    }}
                                  ></Typography> */}

                                  {props?.values?.guest_split[index]
                                    ?.card_verify_token === "" &&
                                  !props.values?.guest_split[index]
                                    ?.suOn ? null : props?.values?.guest_split[
                                      index
                                    ]?.pay === 0 ? (
                                    <Button
                                      variant="contained"
                                      onClick={(e) => {
                                        payNow(
                                          e,
                                          index,
                                          props.setFieldValue,
                                          items,
                                          props.values.guest_split[`${index}`][
                                            "guest"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "payment_card_detail"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "payment_cheque_detail"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "amount"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "payment_type"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "card_present"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "card_verify_token"
                                          ],
                                          selectPinpadDevices,
                                          props.values.guest_split[`${index}`][
                                            "suToken"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "suOn"
                                          ],
                                        );
                                      }}
                                      // sx={{
                                      //   // height: "47px",
                                      //   marginTop: {sm: "35px",xs:"0", md: "0"},
                                      // }}
                                      className="comman-button"
                                    >
                                      {t("Pay Now")}
                                    </Button>
                                  ) : null}
                                </Grid>
                              </Grid>
                            )}

                          {props.values?.guest_split[index]?.card_present ===
                            1 &&
                            props.values?.guest_split[index]?.payment_type ===
                              2 && (
                              <Grid
                                container
                                spacing={2}
                                style={{
                                  marginLeft: "20px",
                                  border: "2px solid #B4ADAD",
                                  borderRadius: "5px",
                                  width: "97%",
                                  marginTop: "25px",
                                  height: "120px",
                                }}
                              >
                                <Grid item lg={4}>
                                  <Typography
                                    style={{
                                      marginBottom: "11px",
                                      color: "rgb(30, 30, 30)",
                                      fontSize: "16px",
                                      lineHeight: "24px",
                                    }}
                                  >
                                    {t("Pinpad Devices")}
                                  </Typography>
                                  <FormControl fullWidth>
                                    <Select
                                      onChange={(e) =>
                                        handlePinpadDevice(
                                          e,
                                          index,
                                          props.setFieldValue,
                                        )
                                      }
                                      defaultValue={0}
                                    >
                                      <MenuItem value={0}>
                                        {t("-- select --")}
                                      </MenuItem>
                                      {pinpadDevicesList?.map((item) => (
                                        <MenuItem
                                          value={item.device_id}
                                          key={item.device_id}
                                        >
                                          {item.device_id}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item lg={2} style={{ left: "50px" }}>
                                  <Typography
                                    style={{
                                      marginBottom: "11px",
                                      color: "rgb(30, 30, 30)",
                                      fontSize: "16px",
                                      lineHeight: "24px",
                                    }}
                                  ></Typography>

                                  {props?.values?.guest_split[index]
                                    ?.selectPinpadDevices === 0 ? null : props
                                      ?.values?.guest_split[index]?.pay ===
                                    0 ? (
                                    <Button
                                      variant="contained"
                                      onClick={(e) => {
                                        payNow(
                                          e,
                                          index,
                                          props.setFieldValue,
                                          items,
                                          props.values.guest_split[`${index}`][
                                            "guest"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "payment_card_detail"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "payment_cheque_detail"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "amount"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "payment_type"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "card_present"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "card_verify_token"
                                          ],
                                          props.values.guest_split[`${index}`][
                                            "selectPinpadDevices"
                                          ],
                                        );
                                      }}
                                      style={{
                                        // height: "47px",
                                        marginTop: "23px",
                                      }}
                                      className="comman-button"
                                    >
                                      {t("Pay Now")}
                                    </Button>
                                  ) : null}
                                </Grid>
                              </Grid>
                            )}
                          {props?.values?.guest_split[index]?.payment_type ===
                            3 && (
                            <Grid
                              container
                              spacing={2}
                              style={{
                                marginLeft: "20px",
                                border: "2px solid #B4ADAD",
                                borderRadius: "5px",
                                width: "97%",
                                marginTop: "20px",
                                height: "120px",
                              }}
                            >
                              <Grid item lg={4}>
                                <Typography
                                  style={{
                                    marginBottom: "11px",
                                    color: "rgb(30, 30, 30)",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                  }}
                                >
                                  {t("Cheque Number")}
                                </Typography>
                                <TextField
                                  placeholder={t("Enter Cheque Number")}
                                  name={`guest_split.${index}.payment_cheque_detail.cheque_number`}
                                  type="number"
                                  value={
                                    props.values?.guest_split[index]
                                      ?.payment_cheque_detail?.cheque_number
                                  }
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      `guest_split.${index}.payment_cheque_detail.cheque_number`,
                                      e.target.value,
                                    )
                                  }
                                  variant="outlined"
                                />
                              </Grid>
                              <Grid item lg={4}>
                                <Typography
                                  style={{
                                    marginBottom: "11px",
                                    color: "rgb(30, 30, 30)",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                  }}
                                >
                                  {t("Bank Name")}
                                </Typography>
                                <TextField
                                  placeholder={t("Enter Bank Name")}
                                  name={`guest_split.${index}.payment_cheque_detail.bank_name`}
                                  value={
                                    props.values?.guest_split[index]
                                      ?.payment_cheque_detail?.bank_name
                                  }
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      `guest_split.${index}.payment_cheque_detail.bank_name`,
                                      e.target.value,
                                    )
                                  }
                                  variant="outlined"
                                />
                              </Grid>
                              <Grid item lg={4}>
                                <Typography
                                  style={{
                                    marginBottom: "11px",
                                    color: "rgb(30, 30, 30)",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                  }}
                                ></Typography>
                                {props?.values?.guest_split[index]?.pay ===
                                0 ? (
                                  <Button
                                    variant="contained"
                                    onClick={(e) => {
                                      payNow(
                                        e,
                                        index,
                                        props.setFieldValue,
                                        items,
                                        props.values.guest_split[`${index}`][
                                          "guest"
                                        ],
                                        props.values.guest_split[`${index}`][
                                          "payment_card_detail"
                                        ],
                                        props.values.guest_split[`${index}`][
                                          "payment_cheque_detail"
                                        ],
                                        props.values.guest_split[`${index}`][
                                          "amount"
                                        ],
                                        props.values.guest_split[`${index}`][
                                          "payment_type"
                                        ],
                                        props.values.guest_split[`${index}`][
                                          "card_present"
                                        ],
                                        props.values.guest_split[`${index}`][
                                          "card_verify_token"
                                        ],
                                      );
                                    }}
                                    className="comman-button"
                                    style={{
                                      // height: "47px",
                                      marginTop: "23px",
                                    }}
                                  >
                                    {t("Pay Now")}
                                  </Button>
                                ) : null}
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      ))}
                  </Grid>
                )}
              </div>

              <div
                className="d-block"
                style={{
                  width: "100%",
                  minHeight: "60px",
                  margin: "auto",
                  border: "1px solid gray",
                }}
              >
                <div
                  style={{
                    padding: "10px",
                    alignItems: "center",
                  }}
                  className="d-flex"
                >
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => {
                            const { checked } = e.target;
                            if (checked) {
                              setCheck(1);
                              props.setFieldValue(`is_late_check_out`, 1);
                            } else {
                              setCheck(2);
                              props.setFieldValue(`is_late_check_out`, 0);
                            }
                          }}
                        />
                      }
                      label={t("Late check-out")}
                    />
                  </FormGroup>
                </div>
                {check === 1 && (
                  <div
                    style={{
                      // width: "100%",
                      padding: "10px",
                      alignItems: "center",
                    }}
                    // style={{
                    //   marginTop: "-46px",
                    //   marginLeft: "200px",
                    // }}
                  >
                    <Typography
                      style={{
                        // marginBottom: "-16px",
                        color: "rgb(63 69 85)",
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: 500,
                      }}
                    >
                      {t("Price")} :-
                    </Typography>
                    <Field
                      name="late_check_out_price"
                      placeHolder="Price"
                      component={FormikInput1}
                    />
                  </div>
                )}
              </div>

              <div
                className="d-block mt-2"
                style={{
                  width: "100%",
                  minHeight: "60px",
                  margin: "auto",
                  border: "1px solid gray",
                }}
              >
                <div
                  style={{
                    padding: "10px",
                    alignItems: "center",
                  }}
                  className="d-flex"
                >
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => {
                            const { checked } = e.target;
                            if (checked) {
                              setCharge_less(1);
                              props.setFieldValue(`is_custom_capture`, 1);
                            } else {
                              setCharge_less(0);
                              props.setFieldValue(`is_custom_capture`, 0);
                            }
                          }}
                          // checked={props?.values?.is_custom_capture === 1}
                          checked={charge_less === 1}
                        />
                      }
                      label={t("Do you want to charge less amount?")}
                    />
                  </FormGroup>
                </div>
                {charge_less === 1 && (
                  <div
                    style={{
                      padding: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <Typography
                        variant="h4"
                        style={{
                          marginTop: "10px",
                          marginBottom: "10px",
                          fontSize: "110%",
                        }}
                      >
                        {t("Payment Summary Info")}
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <TableContainer>
                        <Table
                          sx={{
                            borderCollapse: "collapse",
                            minWidth: "800px",
                          }}
                        >
                          <TableHead>
                            <TableRow sx={{ overflowWrap: "anywhere" }}>
                              <>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  width="5%"
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {" "}
                                    {"#"}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  width="10%"
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {" "}
                                    {t("Inv No.")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  width="20%"
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {t("Transaction Type")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  width="15%"
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {t("Amount")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  width="15%"
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {t("Date Time")}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    whiteSpace: "wrap",
                                  }}
                                  width="20%"
                                >
                                  <Typography
                                    variant="h4"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {t("Card Number")}
                                  </Typography>{" "}
                                </TableCell>
                              </>
                            </TableRow>
                          </TableHead>

                          {bookingInfo?.bookingPaymentSummary?.filter(
                            (item) =>
                              item?.summary_type === 0 &&
                              +item?.transaction_type === 2,
                          )?.length > 0 ? (
                            bookingInfo?.bookingPaymentSummary
                              ?.filter(
                                (item) =>
                                  item?.summary_type === 0 &&
                                  +item?.transaction_type === 2,
                              )
                              ?.map((data, index) => {
                                return data.amount > 0 ? (
                                  <TableBody key={data?.id}>
                                    <TableRow sx={{ overflowWrap: "anywhere" }}>
                                      <>
                                        <TableCell
                                          sx={{
                                            padding: "10px 5px",
                                            borderTop: "1px solid #B4ADAD",
                                            whiteSpace: "wrap",
                                          }}
                                        >
                                          {index + 1}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding: "10px 5px",
                                            borderTop: "1px solid #B4ADAD",
                                            whiteSpace: "wrap",
                                          }}
                                        >
                                          {data.invoice_number}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding: "10px 5px",
                                            borderTop: "1px solid #B4ADAD",
                                            whiteSpace: "wrap",
                                          }}
                                        >
                                          <p>
                                            {data.payment_type === 1
                                              ? t("Cash - ")
                                              : data.payment_type === 2
                                                ? t("Credit Card - ")
                                                : data.payment_type === 3
                                                  ? t("Cheque - ")
                                                  : ""}
                                            {data.transaction_type === 1
                                              ? t("Authorize")
                                              : data.transaction_type === 2
                                                ? t("Charge")
                                                : data.transaction_type === 3
                                                  ? t("Refund")
                                                  : data.transaction_type === 4
                                                    ? t("Void")
                                                    : ""}
                                          </p>
                                          <p>
                                            {data?.is_captured === 1
                                              ? t("- Charged")
                                              : ""}
                                            {data.transaction_type === 1 &&
                                            data?.is_voided === 1
                                              ? t(" - voided")
                                              : ""}
                                            {+data?.refunded_amount === 0
                                              ? ""
                                              : ` ${t("- Remaining")} $ ${(
                                                  +data.amount -
                                                  +data?.refunded_amount
                                                ).toFixed(2)}`}
                                          </p>
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding: "10px 5px",
                                            borderTop: "1px solid #B4ADAD",
                                            whiteSpace: "wrap",
                                          }}
                                        >
                                          {data.amount}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding: "10px 5px",
                                            borderTop: "1px solid #B4ADAD",
                                            whiteSpace: "wrap",
                                          }}
                                        >
                                          {moment(data.date_time).format(
                                            "MM-DD-YYYY hh:mm A",
                                          )}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding: "10px 5px",
                                            borderTop: "1px solid #B4ADAD",
                                            whiteSpace: "wrap",
                                          }}
                                        >
                                          {data.payment_type === 1
                                            ? data?.is_pos === 0
                                              ? t("Lodging")
                                              : t("Food & Beverages")
                                            : getCardMerchantType(
                                                data.merchant_type,
                                              ) +
                                              " - " +
                                              data?.card_number}
                                        </TableCell>
                                      </>
                                    </TableRow>
                                  </TableBody>
                                ) : null;
                              })
                          ) : (
                            <TableBody>
                              <TableRow sx={{ overflowWrap: "anywhere" }}>
                                <TableCell
                                  colSpan="10"
                                  style={{ textAlign: "center" }}
                                  className="text-center"
                                >
                                  {t("No Data Found")}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                        </Table>
                      </TableContainer>
                    </div>
                    <div className="d-flex mt-1">
                      <Grid container spacing={2} alignItems="flex-start">
                        <Grid item xs={12} lg={4}>
                          <Typography
                            variant="h4"
                            style={{
                              marginBottom: "5px",
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          >
                            {t("Select Night")}
                          </Typography>
                          <FormControl fullWidth>
                            <Select
                              labelId="demo-simple-select-label"
                              value={charge_less_detail?.night}
                              onChange={(e) =>
                                handleChargeNight(e, props?.setFieldValue)
                              }
                            >
                              {/* <MenuItem value={0}>{t("Select Night")}</MenuItem> */}
                              {Array.from(
                                { length: bookingInfo?.no_of_days },
                                (_, i) => i + 1,
                              )?.map((items) => (
                                <MenuItem value={+items}>
                                  {items} {t("Nights")} - ${" "}
                                  {
                                    +(
                                      bookingItemInfo?.reduce(
                                        (sum, item) =>
                                          sum +
                                          getSubTotal(
                                            item?.roomRateDetail,
                                            +items,
                                            item?.no_of_extra_adults,
                                            item?.no_of_extra_children,
                                            item?.discountPercentage,
                                          ),
                                        0,
                                      ) *
                                      ((100 - +charge_less_detail?.discount) /
                                        100)
                                    )?.toFixed(2)
                                  }
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <h6 className="mb-1">{t("Discount (in %)")}</h6>
                          <TextField
                            name={"discount"}
                            onChange={(e) =>
                              handleDiscountChargeCapture(
                                e,
                                props?.setFieldValue,
                              )
                            }
                            value={charge_less_detail?.discount}
                            variant="outlined"
                            type="number"
                            placeholder={t("Enter Discount Percentage")}
                          />
                        </Grid>
                           <Grid item xs={12} lg={4}>
                          <h6 className="mb-1">
                            {t("Total Past Redeem")}
                            <span style={{ color: "red" }}> *</span>
                          </h6>
                          <TextField
                            name={"Total Past Redeem"}
                            // onChange={(e) => handleChargeCapture(e)}
                            value={
                              +bookingItemInfo?.[0]?.total_redeem_value.toFixed(
                                2,
                              )
                            }
                            variant="outlined"
                            type="number"
                            placeholder={t("Enter Amount")}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                          />
                        </Grid>
                           <Grid item xs={12} lg={4}>
                          <h6 className="mb-1">
                            {t("Currunt Redeem")}
                            <span style={{ color: "red" }}> *</span>
                          </h6>
                          <TextField
                            name={"Currunt Redeem"}
                            // onChange={(e) => handleChargeCapture(e)}
                            value={
                              +charge_less_detail?.reedemed_reward_value.toFixed(
                                2,
                              )
                            }
                            variant="outlined"
                            type="number"
                            placeholder={t("Enter Amount")}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <h6 className="mb-1">{t("Sub Total")}</h6>
                          <TextField
                            name={"sub_total"}
                            value={(+charge_less_detail?.sub_total).toFixed(2)}
                            variant="outlined"
                            type="number"
                            placeholder={t("Enter Amount")}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                          />
                        </Grid>
                     
                        <Grid item xs={12} lg={4}>
                          <h6 className="mb-1">
                            {t("Final Amount")}
                            <span style={{ color: "red" }}> *</span>
                          </h6>
                          <TextField
                            name={"final_capture_amount"}
                            // onChange={(e) => handleChargeCapture(e)}
                            value={
                              +charge_less_detail?.final_capture_amount.toFixed(
                                2,
                              )
                            }
                            variant="outlined"
                            type="number"
                            placeholder={t("Enter Amount")}
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <h6 className="mb-1">
                            {t("Enter Description")}
                            <span style={{ color: "red" }}> *</span>
                          </h6>
                          <TextField
                            name={"description"}
                            onChange={(e) =>
                              handleChargeCapture(e, props?.setFieldValue)
                            }
                            variant="outlined"
                            value={charge_less_detail?.description}
                            type="text"
                            placeholder={t("Enter Description")}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="d-flex"
                style={{
                  width: "100%",
                  minHeight: "70px",
                  margin: "auto",
                  justifyContent: "end",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    padding: "0px",
                    alignItems: "center",
                  }}
                  className="d-flex"
                >
                  <Grid container spacing={2} alignItems="end">
                    <Grid item>
                      <Button
                        className="mt-1 comman-cancel-button"
                        size="large"
                        onClick={() => handleDialogClose()}
                        variant="contained"
                        disableElevation
                        // type="submit"
                        color="primary"
                      >
                        {t("Close")}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        className="mt-1 comman-button"
                        size="large"
                        variant="contained"
                        disableElevation
                        disabled={auth?.loading}
                        type="submit"
                        color="primary"
                      >
                        {t("Confirm")}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you want to send sms/email to the user?")}
        cancelButtonText={t("No")}
        confirmButtonText={t("Yes")}
        openDialog={openSendSmsEmailDialog}
        handleDialogCloseAction={() => handleSubmit(checkOutValues, 0)}
        handleDialogClose={() => setOpenSendSmsEmailDialog(false)}
        handleDialogAction={() => handleSubmit(checkOutValues, 1)}
        print={print}
        onChangePrint={handleChangePrint}
        printable
        printLabel={t("Do you want to print receipt?")}
      />

      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you want to refund cash by system?")}
        cancelButtonText={t("by Own")}
        confirmButtonText={t("by System")}
        openDialog={openCashRefundDialog}
        handleDialogCloseAction={() => handleCashAction(false)}
        handleDialogClose={() => setOpenCashRefundDialog(false)}
        handleDialogAction={() => handleCashAction(true)}
      />

      {/* credit card Refund dialog  */}
      <DialogForm
        scroll="paper"
        maxWidth="lg"
        // maxWidth="mb"
        title={t("Refund Payment")}
        openDialog={openCreditCardDialog}
        handleDialogClose={() => setOpenCreditCardDialog(false)}
        bodyContent={
          <div className="p-2">
            <div className="d-flex justify-content-between align-items-center">
              <Typography
                variant="h4"
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  fontSize: "110%",
                }}
              >
                {t("Select Refund Method")}
              </Typography>
              <Typography
                variant="h4"
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  fontSize: "110%",
                }}
              >
                {t("Refund Amount")} :{" "}
                {
                  +(
                    +old_captured_amount -
                    +charge_less_detail?.final_capture_amount
                  ).toFixed(2)
                }
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <TableContainer>
                <Table
                  sx={{
                    borderCollapse: "collapse",
                    minWidth: "800px",
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ overflowWrap: "anywhere" }}>
                      <>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="5%"
                        >
                          <Checkbox />
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="5%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {" "}
                            {"#"}
                          </Typography>
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="10%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {" "}
                            {t("Inv No.")}
                          </Typography>{" "}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="20%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {t("Transaction Type")}
                          </Typography>{" "}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="15%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {t("Amount")}
                          </Typography>{" "}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="15%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {t("Date Time")}
                          </Typography>{" "}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="20%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {t("Card Number")}
                          </Typography>{" "}
                        </TableCell>
                      </>
                    </TableRow>
                  </TableHead>

                  {bookingInfo?.bookingPaymentSummary?.filter(
                    (item) =>
                      item?.summary_type === 0 && +item?.transaction_type === 2,
                  )?.length > 0 ? (
                    bookingInfo?.bookingPaymentSummary
                      ?.filter(
                        (item) =>
                          item?.summary_type === 0 &&
                          +item?.transaction_type === 2,
                      )
                      ?.map((data, index) => {
                        return data.amount > 0 ? (
                          <TableBody key={data?.id}>
                            <TableRow sx={{ overflowWrap: "anywhere" }}>
                              <>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    borderTop: "1px solid #B4ADAD",
                                    whiteSpace: "wrap",
                                  }}
                                >
                                  <Checkbox
                                    checked={refundSelectedCard?.includes(
                                      data?.id,
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setRefundSelectedCard((prev) => [
                                          ...prev,
                                          data?.id,
                                        ]);
                                      } else {
                                        setRefundSelectedCard(
                                          refundSelectedCard.filter(
                                            (card) => card !== data?.id,
                                          ),
                                        );
                                      }
                                    }}
                                  />
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    borderTop: "1px solid #B4ADAD",
                                    whiteSpace: "wrap",
                                  }}
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    borderTop: "1px solid #B4ADAD",
                                    whiteSpace: "wrap",
                                  }}
                                >
                                  {data.invoice_number}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    borderTop: "1px solid #B4ADAD",
                                    whiteSpace: "wrap",
                                  }}
                                >
                                  <p>
                                    {data.payment_type === 1
                                      ? t("Cash - ")
                                      : data.payment_type === 2
                                        ? t("Credit Card - ")
                                        : data.payment_type === 3
                                          ? t("Cheque - ")
                                          : ""}
                                    {data.transaction_type === 1
                                      ? t("Authorize")
                                      : data.transaction_type === 2
                                        ? t("Charge")
                                        : data.transaction_type === 3
                                          ? t("Refund")
                                          : data.transaction_type === 4
                                            ? t("Void")
                                            : ""}
                                  </p>
                                  <p>
                                    {data?.is_captured === 1
                                      ? t("- Charged")
                                      : ""}
                                    {data.transaction_type === 1 &&
                                    data?.is_voided === 1
                                      ? t(" - voided")
                                      : ""}
                                    {+data?.refunded_amount === 0
                                      ? ""
                                      : ` ${t("- Remaining")} $ ${(
                                          +data.amount - +data?.refunded_amount
                                        ).toFixed(2)}`}
                                  </p>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    borderTop: "1px solid #B4ADAD",
                                    whiteSpace: "wrap",
                                  }}
                                >
                                  {data.amount}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    borderTop: "1px solid #B4ADAD",
                                    whiteSpace: "wrap",
                                  }}
                                >
                                  {moment(data.date_time).format(
                                    "MM-DD-YYYY hh:mm A",
                                  )}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px 5px",
                                    borderTop: "1px solid #B4ADAD",
                                    whiteSpace: "wrap",
                                  }}
                                >
                                  {data.payment_type === 1
                                    ? data?.is_pos === 0
                                      ? t("Lodging")
                                      : t("Food & Beverages")
                                    : getCardMerchantType(data.merchant_type) +
                                      " - " +
                                      data?.card_number}
                                </TableCell>
                              </>
                            </TableRow>
                          </TableBody>
                        ) : null;
                      })
                  ) : (
                    <TableBody>
                      <TableRow sx={{ overflowWrap: "anywhere" }}>
                        <TableCell
                          colSpan="10"
                          style={{ textAlign: "center" }}
                          className="text-center"
                        >
                          {t("No Data Found")}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </div>
            <Button
              className="mt-1 comman-button"
              size="large"
              variant="contained"
              disableElevation
              onClick={handleConfirmRefundSelected}
              color="primary"
            >
              {t("Confirm")}
            </Button>
          </div>
        }
      />

      {/* Revert Reward dialog  */}
      <DialogForm
        scroll="paper"
        maxWidth="lg"
        // maxWidth="mb"
        title={t("Reward Applied Dialog")}
        openDialog={rewardRevertSelectDialog}
        handleDialogClose={() => setRewardRevertSelectDialog(false)}
        bodyContent={
          <div className="p-2">
            <div className="d-flex justify-content-between align-items-center">
              <Typography
                variant="h4"
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  fontSize: "110%",
                }}
              >
                {t("Select Reward Applied Method")}
              </Typography>
              <Typography
                variant="h4"
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  fontSize: "110%",
                }}
              >
                {t("Reward Applied Value")} :{" "}
                {
                  +(+charge_less_detail?.reedemed_reward_value).toFixed(2)
                }
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <TableContainer>
                <Table
                  sx={{
                    borderCollapse: "collapse",
                    minWidth: "800px",
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ overflowWrap: "anywhere" }}>
                      <>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="5%"
                        >
                          <Checkbox />
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="5%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {" "}
                            {"No."}
                          </Typography>
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="10%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {" "}
                            {t("Name")}
                          </Typography>{" "}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="20%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {t("Reward")}
                          </Typography>{" "}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "10px 5px",
                            whiteSpace: "wrap",
                          }}
                          width="15%"
                        >
                          <Typography variant="h4" sx={{ fontSize: "14px" }}>
                            {t("Reward Value")}
                          </Typography>{" "}
                        </TableCell>
                      </>
                    </TableRow>
                  </TableHead>

                  {bookingInfo?.bookingRedemptions?.length > 0 ? (
                    bookingInfo?.bookingRedemptions?.map((item, index) => {
                      return (
                        <TableBody key={item?.loyalty_program_id}>
                          <TableRow sx={{ overflowWrap: "anywhere" }}>
                            <>
                              <TableCell
                                sx={{
                                  padding: "10px 5px",
                                  borderTop: "1px solid #B4ADAD",
                                  whiteSpace: "wrap",
                                }}
                              >
                                <Checkbox
                                  checked={rewardRevertValues?.includes(
                                    item?.loyalty_program_id,
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setRewardRevertValues((prev) => [
                                        ...prev,
                                        item?.loyalty_program_id,
                                      ]);
                                    } else {
                                      setRewardRevertValues(
                                        rewardRevertValues.filter(
                                          (card) =>
                                            card !== item?.loyalty_program_id,
                                        ),
                                      );
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "10px 5px",
                                  borderTop: "1px solid #B4ADAD",
                                  whiteSpace: "wrap",
                                }}
                              >
                                {index + 1}
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "10px 5px",
                                  borderTop: "1px solid #B4ADAD",
                                  whiteSpace: "wrap",
                                }}
                              >
                                {item?.loyaltyProgramInfo?.program_name || ""}
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "10px 5px",
                                  borderTop: "1px solid #B4ADAD",
                                  whiteSpace: "wrap",
                                }}
                              >
                                {item?.redeemed_points}
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "10px 5px",
                                  borderTop: "1px solid #B4ADAD",
                                  whiteSpace: "wrap",
                                }}
                              >
                                {item?.redeem_value}
                              </TableCell>
                            </>
                          </TableRow>
                        </TableBody>
                      );
                    })
                  ) : (
                    <TableBody>
                      <TableRow sx={{ overflowWrap: "anywhere" }}>
                        <TableCell
                          colSpan="10"
                          style={{ textAlign: "center" }}
                          className="text-center"
                        >
                          {t("No Data Found")}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </div>
            <Button
              className="mt-1 comman-button"
              size="large"
              variant="contained"
              disableElevation
              onClick={handleConfirmRewardRevertSelected}
              color="primary"
            >
              {t("Confirm")}
            </Button>
          </div>
        }
      />

        {/* confirm revert reward */}
       <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you want to revert used rewards?")}
        cancelButtonText={t("No")}
        confirmButtonText={t("Yes, Revert")}
        openDialog={rewardRevertConfirmDialog}
        handleDialogCloseAction={() => handleConfirmRewardRevert(false, checkOutValues)}
        handleDialogClose={() => setRewardRevertConfirmDialog(false)}
        handleDialogAction={() => handleConfirmRewardRevert(true, checkOutValues)}
      />

      <div
        style={{ width: "95%" }}
        className="d-flex justify-content-center"
      ></div>
    </div>
  );
};

export default ReservationCheckOut;
